/**
 * @Page ROM4L
 * @Description [ROM4L]납입지시 - 기초관리 - ERP_품목관리
 **/
import React, { useState, useEffect, useRef, useCallback } from 'react';
import Ribbon from '@/components/organisms/Ribbon';
import ContentXearch from '@/components/organisms/ContentXearch';
import ContentTwo from '../../components/organisms/ContentTwo';
import Grid from '@/components/grid/agGrid';
import CustomAlert from '@/components/molecules/CustomAlert';
import AlertDialog from '@/components/material-UI/AlertDialog';
import * as Common from '@/utils/Common';
import CommonUtil from '@/utils/CommonUtil';
import { getAdaptiveFontSize, parseSubPrintValue, SUB_PRINT_POSITION_VALUES } from '@/utils/printLabel';
import Loading from 'src/components/atoms/CustomLoading2';
import CustomDataMatrix from '@/components/atoms/CustomDataMatrix';

const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER;
const Utils = new CommonUtil();

const SAMPLER_TYPE_TABS = [
	{ type: 'A', sheetCount: 4 },
	{ type: 'B', sheetCount: 6 },
	{ type: 'C', sheetCount: 12 },
];


function ROM4L() {
	const token = Common.getToken();
	const userId = Common.getToken('id');
	const tVnt1 = Common.getToken('vand');
	const tComp = Common.getToken('comp');
	const grdRom4lMain = useRef(); //Grid Main
	let [loading, setLoading] = useState(false);
	const ckVnt1 =
		Common.getCookie('ck_vnt1' + userId) === null || Common.getCookie('ck_vnt1' + userId) === '' || Common.getCookie('ck_vnt1' + userId) === 'undefined'
			? tVnt1
			: Common.getCookie('ck_vnt1' + userId);

	const pattern_kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // 한글체크
	const pattern_num = /[0-9]/; // 숫자
	const pattern_spc = /[~!.'/@#$%^&*()_+|<>?\\:={}-]/; // 특수문자
	const pattern_eng = /[a-zA-Z]/; // 문자
	const [panded, setPanded] = React.useState(true);
	const [showPreview, setShowPreview] = useState(false);
	// previewMidBg, previewBotBg, previewLrSizeMode 제거 → idata.wrcbgndT, idata.wrcbgnd2B, idata.wdccklg 직접 사용
	// 이중인쇄 샘플러 상태
	const [samplerOpen, setSamplerOpen] = useState(false);
	const [samplerPresets, setSamplerPresets] = useState([]);
	const [samplerHasAnyPresets, setSamplerHasAnyPresets] = useState(false);
	const [samplerActiveType, setSamplerActiveType] = useState('A');
	const [samplerSelIdx, setSamplerSelIdx] = useState(-1);
	const [samplerLoading, setSamplerLoading] = useState(false);
	const samplerRequestSeqRef = useRef(0);
	const detailRequestSeqRef = useRef(0);
	const samplerOpenRef = useRef(false);

	// 미리보기 플로팅 창 드래그 이동 상태
	const [modalPos, setModalPos] = useState({ x: null, y: 80 });
	const [isDragging, setIsDragging] = useState(false);
	const dragStartPos = React.useRef({ mouseX: 0, mouseY: 0, modalX: 0, modalY: 0 });

	// 샘플 선택 전 기존 설정값 백업 스냅샷 레퍼런스
	const initialDualPrintStateRef = React.useRef(null);

	const onMouseDownHeader = (e) => {
		if (e.target.tagName === 'BUTTON' || e.target.closest('button')) return;
		e.preventDefault();
		const modalElement = e.currentTarget.parentElement;
		const rect = modalElement.getBoundingClientRect();
		dragStartPos.current = {
			mouseX: e.clientX,
			mouseY: e.clientY,
			modalX: rect.left,
			modalY: rect.top,
		};
		setIsDragging(true);
	};

	React.useEffect(() => {
		const onMouseMove = (e) => {
			if (!isDragging) return;
			const dx = e.clientX - dragStartPos.current.mouseX;
			const dy = e.clientY - dragStartPos.current.mouseY;
			setModalPos({
				x: Math.max(0, Math.min(window.innerWidth - 300, dragStartPos.current.modalX + dx)),
				y: Math.max(0, Math.min(window.innerHeight - 100, dragStartPos.current.modalY + dy)),
			});
		};
		const onMouseUp = () => {
			if (isDragging) setIsDragging(false);
		};
		if (isDragging) {
			window.addEventListener('mousemove', onMouseMove);
			window.addEventListener('mouseup', onMouseUp);
		}
		return () => {
			window.removeEventListener('mousemove', onMouseMove);
			window.removeEventListener('mouseup', onMouseUp);
		};
	}, [isDragging]);
	// const [style, setStyle] = useState({ height: 'calc(100vh - 60px - 50px - 100px - 50px)', paddingTop: '10px' });
	// const [style, setStyle] = useState({ height :"calc(100vh - 65px - 35px - 21px - 101px )" });
	// const [style, setStyle] = useState({ height :window.innerHeight - 500});
	const [style, setStyle] = useState({ height: "calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px - 10px)", paddingTop: '10px' });

	//Data
	const [idata, setData] = useState({
		//조회조건
		kVnt1: ckVnt1, // T1업체
		kComp: tComp, // 회사구분
		kPlnt: '', // 공장
		kPtno: '', // 품번
		kEmgubn: '1',
		kVnt1Nm: '', // T1업체명
		kCompNm: tComp === 'EHMC' ? '현대자동차(주)' : '기아자동차(주)', // 회사명

		//코드 데이터
		vnt1List: [], // T1업체
		plntList: [], // 공장
		compList: [], // 회사구분
		gateList: [], // 하치장
		typeList: [], // 식별표타입
		wdcspecList: [], // 지역
		wdcckgbList: [], // L/R

		//입력데이터
		wdcplnt: '', // 공장
		wdcptno: '', // 품번
		wdcptnm: '', // 품명
		wdcgate: '', // 대표하치장
		wdcsjgb: '', // 실적구분
		wdcnpgb: '', // 납품서구분
		wdccase: '', // 용기코드
		wdcqypc: '', // 용기당수량
		wdciggb: '', // 입고방식
		wdcfrdt: '', // 효력시작일
		wdctodt: '', // 효력종료일
		wdcokgb: '', // 검수유무
		wdcdono: '', // 구매문서
		wdcdopt: '', // 품목번호
		wdccrdx: '', // 담당자
		//하치장1 ~ 10
		wdcgate1: '',
		wdcgate2: '',
		wdcgate3: '',
		wdcgate4: '',
		wdcgate5: '',
		wdcgate6: '',
		wdcgate7: '',
		wdcgate8: '',
		wdcgate9: '',
		wdcgate10: '',
		wdckorn: '', // 한글품명
		wdctrst: '', // 공급자
		//공정No
		wdcshop1: '',
		wdcline1: '',
		wdcaspr1: '',
		wdcrack1: '',
		//HPC
		wdccarc: '',
		wdcalct: '',
		wdcdlgt: '',
		wdcgjno: '', // 공정
		wdcprcd: '', // 조립코드
		wdcalcc: '', // ALC
		wdcnppr: '', // 납품단가
		wdclane: '', // LANE
		wdcoptn: '', // 특기
		wdcptgb: '', // 식별표 Type
		wdcstck: '', // 부착면수
		wdcspec: '', // 지역
		wdcckgb: '', // L/R
		wdccklg: '', // L/R 크기 (S=작게, L=크게)
		wdcrthd: 'N', // RHD적용
		wdclthd: 'N', // LHD적용
		wdcflag: 'Y', // 사용여부
		wdclbl1: '', // 내용
		wdccol1: '', // 색상
		wdcsiz1: '', // 폰트사이즈
		wdcprx1: '', // X좌표
		wdcpry1: '', // Y좌표
		wdclbl2: '', // 이중인쇄 내용
		wdccol2: '', // 색상
		wdcsiz2: '', // 폰트사이즈
		wdcprx2: '', // X좌표
		wdcpry2: '', // Y좌표
		wdcwtun: '', // 적입중량
		wrcvnqt: '', // 업체별 용기당수량
		wrcvnyn: '', // 업체별 용기당수량 사용여부
		wrcbgnd: '',   // 배경색 조합값 (예: 'YG', 'NP', 'NN')
		wrcbgndT: 'N', // 배경색 중앙 (Y=노랑, N=없음)
		wrcbgnd2B: 'N', // 배경색 하단 (P=보라, G=초록, N=없음)
		wrcpsub: '' // ARGB 색상(앞 8자리) + 보조 인쇄 문구
	});
	const selectedSubPrintPosition = parseSubPrintValue(idata.wrcpsub).position;

	const [message, setMessage] = React.useState({
		openAlert: false,
		severity: 'success',
		msg: '',
	});
	const { openAlert, severity, msg } = message;

	//Dialog
	const [dlgMessage, setDlgMessage] = React.useState({
		openDlg: false,
		dlgTrans: '',
		dlgMsg: '',
	});
	const { openDlg, dlgTrans, dlgMsg } = dlgMessage;

	let [searchApi, setSearchApi] = useState(false);
	let [deleteApi, setDeleteApi] = useState(false);

	let [clearGrid, setClearGrid] = useState(false);

	const onClearApi = useCallback(async (e) => {
		setSearchApi(false);
		setDeleteApi(false);
	}, []);

	const onClick = async (e) => {
		setPanded(!panded);

		if (panded === true) {
			setStyle({
				// height: 'calc(100vh - 60px - 50px - 50px )',
				height: "calc(100vh - 65px - 35px - 50px - 21px - 8px - 10px)",
				padingTop: '10px',
			});
		} else {
			setStyle({
				// height: 'calc(100vh - 60px - 50px - 100px - 50px )',
				// height: 'calc(100vh - 65px - 35px - 50px - 21px - 101px - 10px )',
				height: "calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px - 10px)",
				paddingTop: '10px',
			});
		}
	};

	/**
	 * 공통코드 조회 (조회조건)
	 */
	const onSearchCommon = (para, name) => {
		let commonData = idata;

		const fetchData = async (para, name) => {
			let param = encodeURIComponent(para);
			const query = SERVER_URL + '/comcd/search?query=' + param;
			await fetch(query, { headers: { Authorization: token } })
				.then((resp) => resp.json())
				.then((data) => {
					if (data.success) {
						if (name === 'plntList') {
							if (data.data.length > 0) {
								commonData['kPlnt'] = data.data[0].comCode;
								commonData['kPlntNm'] = data.data[0].text;
							}
						}
						commonData[name] = data.data;
						setData({ ...commonData });
					}
				});
		};
		fetchData(para, name);
	};

	/**
	 * (식별표 타입, 지역) 조회
	 * @param {*} para
	 * @param {*} name
	 */
	const onSearchCommon1 = (para, name) => {
		let commonData = idata;

		const fetchData1 = async (para, name) => {
			let param = encodeURIComponent(para);
			const query = SERVER_URL + '/comcd/search1?query=' + param;
			await fetch(query, { headers: { Authorization: token } })
				.then((resp) => resp.json())
				.then((data) => {
					if (data.success) {
						if (name === 'typeList') {
						}
						commonData[name] = data.data;
						setData({ ...commonData });
					}
				});
		};
		fetchData1(para, name);
	};

	const onSearchCommon2 = (para, name) => {
		let commonData = idata;

		const fetchData = async (para, name) => {
			let param = encodeURI(para);
			const query = SERVER_URL + '/comcd/search?query=' + param;
			await fetch(query, { headers: { Authorization: token } })
				.then((resp) => resp.json())
				.then((data) => {
					if (data.success) {
						commonData[name] = data.data[0].text;
						setData({ ...commonData });
					}
				});
		};
		fetchData(para, name);
	};

	/**
	 *MOUNT
	 */
	useEffect(() => {
		//공통코드 조회 (T1업체)
		onSearchCommon(`{"pgmid":"VNT1"}`, 'vnt1List');
		//공통코드 조회 (공장)
		onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":""}`, 'plntList');

		//공통코드 조회 (회사구분)
		onSearchCommon1(`{"pgmid":"CODE", "vand":"****", "gocd":"COMP"}`, 'compList');

		//공통코드 조회 (식별표타입)
		onSearchCommon1(`{"pgmid":"CODE", "vand":"****", "gocd":"PTCD"}`, 'typeList');

		//공통코드 조회 (지역)
		onSearchCommon1(`{"pgmid":"CODE", "vand":"****", "gocd":"SPEC"}`, 'wdcspecList');

		//공통코드 조회 (L/R))
		onSearchCommon1(`{"pgmid":"CODE", "vand":"****", "gocd":"CKGB"}`, 'wdcckgbList');
		onSearchCommon2(`{"pgmid":"WRCVAND","kVnt1":"${idata.kVnt1}"}`, 'kVnt1Nm');
	}, []);

	/**
	 * Control 변경 Event
	 * @param {*} e
	 */
	const onChange = async (e) => {
		const { name, value, desc } = e.target;

		// let newSearchs = { ...idata };
		let newSearchs = idata;

		newSearchs[name] = value;
		newSearchs[name + 'Nm'] = desc;
		setData({ ...newSearchs });

		//T1업체, 회사구분 변경시
		if (name === 'kVnt1' || name === 'kComp') {
			newSearchs['plntList'] = [];
			newSearchs['gateList'] = [];
			newSearchs['kPlnt'] = '';
			newSearchs[name] = value;
			setData({ ...newSearchs });

			//공통코드 조회 (공장)
			onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":""}`, 'plntList');
		}

		// RHD/LHD 라디오 처리: lrthd 그룹에서 wdcrthd, wdclthd 각각 Y/N 셋팅
		else if (name === 'lrthd') {
			if (value === 'rthd') {
				newSearchs['wdcrthd'] = 'Y';
				newSearchs['wdclthd'] = 'N';
			} else if (value === 'lthd') {
				newSearchs['wdcrthd'] = 'N';
				newSearchs['wdclthd'] = 'Y';
			} else {
				// NO 선택
				newSearchs['wdcrthd'] = 'N';
				newSearchs['wdclthd'] = 'N';
			}
			setData({ ...newSearchs });
		}

		// 배경색 중앙(wrcbgndT) 변경 → wrcbgnd = T+B 합산
		else if (name === 'wrcbgndT') {
			newSearchs['wrcbgndT'] = value;
			newSearchs['wrcbgnd'] = value + (newSearchs['wrcbgnd2B'] || 'N');
			setData({ ...newSearchs });
		}

		// 배경색 하단(wrcbgnd2B) 변경 → wrcbgnd = T+B 합산
		else if (name === 'wrcbgnd2B') {
			newSearchs['wrcbgnd2B'] = value;
			newSearchs['wrcbgnd'] = (newSearchs['wrcbgndT'] || 'N') + value;
			setData({ ...newSearchs });
		}

		//입력항목 (일반)
		else {
			if (name === 'wdcptno') {
				//하이픈(-) 입력 Check
				if (value.includes('-')) {
					setMessage({ openAlert: true, severity: 'info', msg: '하이픈(-)은 입력 할 수 없습니다.' });
					return;
				}
			}

			// Y좌표는 0.5mm 단위 조정을 위해 소수점 한 자리까지 허용한다.
			if (name === 'wdcpry1' || name === 'wdcpry2') {
				if (!/^\d{0,3}(\.\d?)?$/.test(value)) return;
			}
			// 숫자만 입력 Check (용기당수량, 부착면수, 폰트사이즈, x좌표, 납품단가)
			else if (
				name === 'wdcqypc' ||
				name === 'wdcstck' ||
				name === 'wdcsiz1' ||
				name === 'wdcprx1' ||
				name === 'wdcsiz2' ||
				name === 'wdcprx2' ||
				name === 'wdcnppr'
			) {
				if (pattern_spc.test(value) || pattern_kor.test(value) || pattern_eng.test(value)) return;
			} else if (name !== 'wdckorn' && name !== 'wdccklg') {
				if (name !== 'wdclbl1' && name !== 'wdclbl2') {
					// 이중 출력 1,2 "내용" 한글입력 되도록 처리
					if (pattern_kor.test(value)) return; // 한글입력 안되게처리
				}
			}

			newSearchs[name] = value;
			newSearchs[name + 'Nm'] = desc;
			setData({ ...newSearchs });
		}

		//조회조건 변경시 Clear
		if (name === 'kVnt1' || name === 'kComp' || name === 'kPlnt' || name === 'kPtno' || name === 'kEmgubn') {
			setClearGrid(true);
			initInputData();
		}
	};

	/**
	 * Grid Event
	 * @param {*} e
	 */
	const grdRom4lMain_onCellValueChanged = async (e) => { };
	const grdRom4lMain_onRowClicked = async (e) => {
		let data = e.data;
		const rowTypeValue = String(data.wdcptgb || '').trim();
		const lType = rowTypeValue ? getLabelType(rowTypeValue) : null;

		// 상세조회가 끝나기 전에 팝업을 열어도 선택 행의 식별표 타입을 유지한다.
		if (lType) setSamplerActiveType(lType);

		//품목관리 상세 조회
		onSearch2(data);

		// 샘플러가 열려있으면 동일 공장의 샘플 자동 로드
		if (samplerOpen && lType) {
			const plnt = data.wdcplnt;
			onLoadSamplerPresets(plnt, lType);
		}
	};

	/**
	 * 검색조건
	 */
	const optionsX = {
		0: [
			//T1업체
			{
				formatter: 'select',
				name: 'kVnt1',
				labelName: 'T1업체',
				type: 'text',
				defaultValue: idata.kVnt1,
				codeMode: true,
				selectAll: '',
				codes: null,
				comms: idata.vnt1List,
				align: 'left',
			},
			//공장
			{
				formatter: 'select',
				name: 'kPlnt',
				labelName: '공장',
				type: 'text',
				defaultValue: idata.kPlnt,
				codeMode: false,
				selectAll: '',
				codes: null,
				comms: idata.plntList,
			},
			//사용여부
			{
				formatter: 'select',
				name: 'kEmgubn',
				labelName: '사용여부',
				type: 'text',
				defaultValue: idata.kEmgubn,
				codeMode: false,
				selectAll: '',
				codes: [
					{ text: '전체', comCode: '1' },
					{ text: '사용', comCode: '2' },
					{ text: '미사용', comCode: '3' },
				],
				comms: null,
				align: 'left',
			},
			{ formatter: 'blank', align: 'right' },
			{ formatter: 'blank', align: 'right' },
			{ formatter: 'blank', align: 'right' },
		],
		1: [
			//회사구분
			{
				formatter: 'select',
				name: 'kComp',
				labelName: '회사구분',
				type: 'text',
				defaultValue: idata.kComp,
				codeMode: true,
				selectAll: '',
				comms: idata.compList,
				align: 'left',
			},
			//품번
			{
				formatter: 'input',
				name: 'kPtno',
				labelName: '품번',
				type: 'text',
				desc: '',
				readOnly: false,
				defaultValue: idata.kPtno,
				align: 'left',
				labelType: 'none',
			},
			{ formatter: 'blank', align: 'right' },
			{ formatter: 'blank', align: 'right' },
			{ formatter: 'blank', align: 'right' },
			{ formatter: 'blank', align: 'right' },
		],
	};

	/**
	 * 조회
	 * @param {*} e
	 * @returns
	 */
	const onSearch = async (e) => {
		//T1업체선택 Check
		if (idata.kVnt1 == '') {
			setMessage({ openAlert: true, severity: 'info', msg: '1차업체를 선택하십시요 !' });
			document.getElementById('kVnt1').focus();
			return;
		}

		//회사구분선택 Check
		if (idata.kComp == '') {
			setMessage({ openAlert: true, severity: 'info', msg: '회사구분을 선택하십시요 !' });
			document.getElementById('kComp').focus();
			return;
		}

		//공장선택 Check
		if (idata.kPlnt == '') {
			setMessage({ openAlert: true, severity: 'info', msg: '공장을 선택하십시요 !' });
			document.getElementById('kPlnt').focus();
			return;
		}

		// Cookie 값 셋팅
		Common.setCookie('ck_vnt1' + userId, idata.kVnt1, 1);

		let para = `{"kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kPlnt":"${idata.kPlnt}", 
                     "kPtno":"${idata.kPtno}","kEmgubn":"${idata.kEmgubn}"}`;
		let param = encodeURIComponent(para);

		const query = SERVER_URL + '/rom4l/search?query=' + param;
		setSearchApi(query);

		initInputData();
	};

	/**
	 * 입력
	 * @param {*} e
	 */
	const onInsert = async (e) => {
		//input check
		let input = await Promise.all([inputCheck('I')]);
		if (!input[0]) return;

		//품번 입력 Check
		if (idata.wdcptno === '' || idata.wdcptno === null) {
			setMessage({ openAlert: true, severity: 'info', msg: '품번은 필수입력입니다.' });
			return;
		}
		//품명 입력 Check
		if (idata.wdcptnm === '' || idata.wdcptnm === null) {
			setMessage({ openAlert: true, severity: 'info', msg: '품명은 필수입력입니다.' });
			return;
		}

		//품번 하이픈(-) 입력 Check
		if (idata.wdcptno.includes('-')) {
			setMessage({ openAlert: true, severity: 'info', msg: '하이픈(-)은 입력 할 수 없습니다.' });
			return;
		}
		//품번 작은따움표 체크
		if (idata.wdcptno.includes("'")) {
			setMessage({ openAlert: true, severity: 'info', msg: '하이픈(-)은 입력 할 수 없습니다.' });
			return;
		}

		//품명 작은따움표 체크
		if (idata.wdcptnm.includes("'")) {
			setMessage({ openAlert: true, severity: 'info', msg: '하이픈(-)은 입력 할 수 없습니다.' });
			return;
		}

		//공장선택 Check
		if (idata.kPlnt == '') {
			setMessage({ openAlert: true, severity: 'info', msg: '공장을 선택하십시요 !' });
			document.getElementById('kPlnt').focus();
			return;
		}

		//입력 확인 메세지
		setDlgMessage({ openDlg: true, dlgTrans: 'I', dlgMsg: '입력된 품목정보를 등록 하시겠습니까?' });
	};

	/**
	 * 수정
	 * @param {*} e
	 * @returns
	 */
	const onUpdate = async (e) => {
		//check
		let input = await Promise.all([inputCheck('U')]);
		if (!input[0]) return;

		//수정 확인 메세지
		setDlgMessage({ openDlg: true, dlgTrans: 'U', dlgMsg: '데이터를 수정 하시겠습니까?' });
	};

	/**
	 * 삭제
	 * @param {*} e
	 */
	const onDelete = async (e) => {
		//check
		let input = await Promise.all([inputCheck('D')]);
		if (!input[0]) return;

		//삭제 확인 메세지
		setDlgMessage({ openDlg: true, dlgTrans: 'D', dlgMsg: '선택한 데이터를 삭제하시겠습니까?' });
	};

	// input Data init
	// input Data init
	const initInputData = (selectedRow = null) => {
		const defaultNKeys = ['wdcrthd', 'wdclthd', 'wrcbgndT', 'wrcbgnd2B'];
		setData((prev) => {
			const nextData = { ...prev };
			Object.keys(nextData).forEach((key) => {
				if (!key.startsWith('k') && !key.endsWith('List')) {
					nextData[key] = defaultNKeys.includes(key) ? 'N' : '';
				}
			});
			if (selectedRow) {
				nextData.wdcplnt = selectedRow.wdcplnt || '';
				nextData.wdcptno = selectedRow.wdcptno || '';
				nextData.wdcptgb = selectedRow.wdcptgb || '';
			}
			return nextData;
		});
	};

	/**
	 * 품목관리 상세조회
	 * @param {*} e
	 * @returns
	 */
	const onSearch2 = async (e) => {
		const requestSeq = ++detailRequestSeqRef.current;
		initInputData(e);

		const fetchData = async (e) => {
			// 데이터 매핑 공통 함수 (mock / 실제 API 공유)
			const applyData = (row) => {
				if (!row || requestSeq !== detailRequestSeqRef.current) return;

				// 백엔드 row 객체에 포함된 검색조건(k...) 및 드롭다운 코드목록(...List) 등의 빈 값 필드가
				// 기존 idata 상태값(kVnt1, kComp 등)을 덮어써서 지우지 않도록 불필요한 필드 제거
				const cleanRow = { ...row };
				Object.keys(cleanRow).forEach((key) => {
					if (
						key.startsWith('k') ||
						key.endsWith('List') ||
						key === 'vnt1List' ||
						key === 'comp' ||
						key === 'wrcvand' ||
						key === 'wrccomp'
					) {
						delete cleanRow[key];
					}
				});

				const bgndRaw = cleanRow.wrcbgnd || 'NN';
				const resolvedType = getLabelType(cleanRow.wdcptgb || e.wdcptgb);
				const resolvedPlnt = cleanRow.wdcplnt || e.wdcplnt;

				initialDualPrintStateRef.current = null;
				setSamplerSelIdx(-1);

				setData((prev) => ({
					...prev,
					...cleanRow,
					wdccklg: cleanRow.wdccklg || '',
					wdcrthd: cleanRow.wdcrthd === '' ? 'N' : (cleanRow.wdcrthd || 'N'),
					wdclthd: cleanRow.wdclthd === '' ? 'N' : (cleanRow.wdclthd || 'N'),
					wdccol1: cleanRow.wdccol1 === '' ? 'B' : (cleanRow.wdccol1 || 'B'),
					wdccol2: cleanRow.wdccol2 === '' ? 'B' : (cleanRow.wdccol2 || 'B'),
					wrcbgnd: bgndRaw,
					wrcbgndT: bgndRaw.charAt(0) || 'N',
					wrcbgnd2B: bgndRaw.charAt(1) || 'N',
				}));

				// 팝업이 열린 상태에서는 상세 응답의 최종 타입으로 탭과 샘플을 동기화한다.
				if (samplerOpenRef.current) {
					setSamplerActiveType(resolvedType);
					if (resolvedPlnt) onLoadSamplerPresets(resolvedPlnt, resolvedType);
				}
			};

			// ─── 실제 API 호출 ───────────────────────────────────────
			let para = `{"wrcvand":"${e.wrcvand}","wrccomp":"${e.wrccomp}","wdcplnt":"${e.wdcplnt}",
                         "wdcptno":"${e.wdcptno}"}`;

			let param = encodeURIComponent(para);
			const query = SERVER_URL + '/rom4l/search1?query=' + param;

			await fetch(query, { headers: { Authorization: token } })
				.then((resp) => resp.json())
				.then((data) => {
					if (data?.data?.[0]) {
						applyData(data.data[0]);
					}
				})
				.catch((error) => {
					if (error) {
						setMessage({ openAlert: true, severity: 'error', msg: '서버 상태를 확인해 주세요. 관리자에게 문의해주세요.' });
					}
				});
		};

		fetchData(e);
	};

	/**
	 * 엑셀
	 * @param {*} e
	 */
	const onExcel = async (e) => {
		let para = `{"wrcvand":"${idata.kVnt1}","wrccomp":"${idata.kComp}","wdcplnt":"${idata.kPlnt}",
                        "vnt1Nm":"${idata.kVnt1Nm}",
                        "compNm":"${idata.kCompNm}",
                        "plntNm":"${idata.kPlntNm}"
                    }`;

		let param = encodeURIComponent(para);
		const query = SERVER_URL + '/rom4l/excel?query=' + param;

		setLoading(true);

		await fetch(query, { headers: { Authorization: token } })
			.then((resp) => {
				return resp.blob();
			})
			.then((blob) => {
				const href = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = href;
				link.setAttribute('download', 'rom4l.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((err) => {
				return Promise.reject({ Error: 'error', err });
			});

		setLoading(false);

		setMessage({ openAlert: true, severity: 'success', msg: '엑셀파일이 생성되었습니다.' });
	};

	const deepCopy = (obj) => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // 배열인 경우
  if (Array.isArray(obj)) {
    return obj.map(item => deepCopy(item));
  }

  // 객체인 경우
  const copiedObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      copiedObj[key] = deepCopy(obj[key]);
    }
  }

  return copiedObj;
}

	//BackendCall
	const BackendCall = async (e) => {
		const fetchData = async (e) => {

			console.log("idata")
			console.log(deepCopy(idata))

			let url;

			if (e === 'I') {
				url = '/rom4l/insert';
			}
			if (e === 'U') {
				//품번 작은따움표 체크
				if (idata.wdcptno.includes("'")) {
					setMessage({ openAlert: true, severity: 'info', msg: '품번 : 작은 따움표는 입력할 수 없습니다.' });
					return;
				}

				//품명 작은따움표 체크
				if (idata.wdcptnm.includes("'")) {
					setMessage({ openAlert: true, severity: 'info', msg: '품명 : 작은 따움표는 입력할 수 없습니다.' });
					return;
				}

				url = '/rom4l/update';
			}

			const query = SERVER_URL + url;

			let param = JSON.stringify({
				kVnt1: idata.kVnt1,
				kComp: idata.kComp,
				wdcplnt: idata.wdcplnt, // 공장
				wdcptno: idata.wdcptno.toUpperCase(), // 품번
				wdcptnm: idata.wdcptnm.toUpperCase(), // 품명
				wdckorn: idata.wdckorn.toUpperCase(), // 한글품명
				kPlnt: idata.kPlnt, // 공장
				wdcnpgb: idata.wdcnpgb.toUpperCase(), // 납품서구분
				wdcsjgb: idata.wdcsjgb.toUpperCase(), // 실적구분
				wdcgate: idata.wdcgate.toUpperCase(), // 대표하치장
				wdccase: idata.wdccase.toUpperCase(), // 용기코드
				wdcqypc: idata.wdcqypc, // 용기당수량
				wdcokgb: idata.wdcokgb.toUpperCase(), // 검수유무
				wdccrdx: idata.wdccrdx.toUpperCase(), // 담당자
				wdciggb: idata.wdciggb.toUpperCase(), // 입고방식
				wdctrst: idata.wdctrst.toUpperCase(), // 공급자
				wdcshop1: idata.wdcshop1.toUpperCase(), // 공정No1
				wdcline1: idata.wdcline1.toUpperCase(), // 공정No2
				wdcaspr1: idata.wdcaspr1.toUpperCase(), // 공정No3
				wdcrack1: idata.wdcrack1.toUpperCase(), // 공정No4
				wdccarc: idata.wdccarc.toUpperCase(), // HPC1
				wdcalct: idata.wdcalct.toUpperCase(), // HPC2
				wdcdlgt: idata.wdcdlgt.toUpperCase(), // HPC3
				wdcprcd: idata.wdcprcd.toUpperCase(), // 조립코드
				wdcnppr: idata.wdcnppr.toUpperCase(), // 납품단가
				wdcoptn: idata.wdcoptn.toUpperCase(), // 특기
				wdcptgb: idata.wdcptgb, // 식별표 Type
				wdcstck: idata.wdcstck, // 부착면수
				wdcspec: idata.wdcspec, // 지역
				wdcckgb: idata.wdcckgb, // L/R
				wdccklg: idata.wdccklg, // L/R 크기 (S/L)
				wdcrthd: idata.wdcrthd, // RHD적용
				wdclthd: idata.wdclthd, // LHD적용
				wdcflag: idata.wdcflag, // 사용여부
				wdclbl1: idata.wdclbl1.toUpperCase(), // 내용
				wdccol1: idata.wdccol1, // 색상
				wdcprx1: idata.wdcprx1, // X좌표
				wdcpry1: idata.wdcpry1, // Y좌표
				wdcsiz1: idata.wdcsiz1, // 폰트사이즈
				wdclbl2: idata.wdclbl2.toUpperCase(), // 이중인쇄 내용
				wdccol2: idata.wdccol2, // 색상
				wdcprx2: idata.wdcprx2, // X좌표
				wdcpry2: idata.wdcpry2, // Y좌표
				wdcwtun: idata.wdcwtun, // 적입중량 20220630 추가
				wrcvnqt: idata.wrcvnqt, // 업체당 용기당수량 20220811 추가
				wrcvnyn: idata.wrcvnyn, // 업체당 용기당수량 사용여부20220811 추가
				wrcbgnd: idata.wrcbgnd, // 업체당 용기당수량 사용여부20220811 추가
				wrcpsub: idata.wrcpsub || '', // ARGB 색상(앞 8자리) + 보조 인쇄 문구
				wdcsiz2: idata.wdcsiz2, // 폰트사이즈
				wdcgjno: idata.wdcgjno.toUpperCase(), // 공정
				wdcalcc: idata.wdcalcc.toUpperCase(), // ALC
				wdclane: idata.wdclane.toUpperCase(), // LANE
				wdcfrdt: idata.wdcfrdt, // 효력시작일
				wdctodt: idata.wdctodt, // 효력종료일
				wdcgate1: idata.wdcgate1, // 하치장1
				wdcgate2: idata.wdcgate2, // 하치장2
				wdcgate3: idata.wdcgate3, // 하치장3
				wdcgate4: idata.wdcgate4, // 하치장4
				wdcgate5: idata.wdcgate5, // 하치장5
				wdcgate6: idata.wdcgate6, // 하치장6
				wdcgate7: idata.wdcgate7, // 하치장7
				wdcgate8: idata.wdcgate8, // 하치장8
				wdcgate9: idata.wdcgate9, // 하치장9
				wdcgate10: idata.wdcgate10, // 하치장10
			});

			console.log("param 수정 파람확인용")
			console.log("idata")
			console.log(deepCopy(idata))
			console.log(deepCopy(param))




			await fetch(query, { method: 'POST', headers: { Authorization: token, 'Content-Type': 'application/json' }, body: param })
				.then((resp) => resp.json())
				.then((data) => {
					if (data.success) {
						setMessage({ openAlert: true, severity: 'success', msg: '정상적으로 등록되었습니다.' });
					} else if (data.errors) {
						setMessage({ openAlert: true, severity: 'error', msg: data.errors.message });
					} else if (data.error) {
						let message = data.message;

						if (message.search('ORA-00001')) {
							message = '이미 등록된 코드입니다.';
						}

						setMessage({ openAlert: true, severity: 'error', msg: message });
					}
				})
				.catch((error) => {
					// 에러 응답 처리
					if (error) {
						setMessage({ openAlert: true, severity: 'error', msg: '서버 상태를 확인해 주세요. 관리자에게 문의해주세요.' });
					}
				});
		};
		fetchData(e);
	};

	// input check
	const inputCheck = (gbn) => {
		if (tVnt1 != idata.kVnt1) {
			if (gbn != 'U') {
				setMessage({ openAlert: true, severity: 'info', msg: 'T2 업체는 입력 및 삭제가 불가능 합니다.' });
				return false;
			}
		}

		if (gbn == 'D') {

			let selectedData = grdRom4lMain.current.getSelectedNodes();

			// 선택 값 체크
			if (selectedData.length === 0) {
				//Alert 창 OPEN
				setMessage({ openAlert: true, severity: 'info', msg: '선택한 데이터가 없습니다.' });
				return false;
			}
		} else {
			//품명 입력 Check - 입력/수정
			if (idata.wdcptnm === '' || idata.wdcptnm === null) {
				setMessage({ openAlert: true, severity: 'info', msg: '품명은 필수입력입니다.' });
				return;
			}
		}
		return true;
	};


	const AlertDialogResult = async (e) => {
		//AlertDialog 초기화
		setDlgMessage({ openDlg: false, dlgTrans: '', dlgMsg: '' });

		//DialogResult
		if (e.result == 'N') return;

		//Transaction 구분
		switch (e.Trans) {
			//등록
			case 'I':
				BackendCall(e.Trans);
				break;
			//수정
			case 'U':
				BackendCall(e.Trans);
				break;
			//삭제
			case 'D':
				const queryD = SERVER_URL + '/rom4l/delete';
				setDeleteApi(queryD); // Update API
				break;
		}
	};

	/**
	 * Grid Bind Data
	 * @returns
	 */
	const onGridBindData = (para) => { };

	/**
	 *Grid Column 정의
	 */
	//Main Grid Column
	const columnDefs = [
		{
			headerName: 'wrcvand',
			field: 'wrcvand',
			sortable: true,
			filter: true,
			flex: 1,
			minWidth: 100,
			editable: false,
			headerClass: '',
			cellClass: ['nocheckbox', 'alignC'],
			singleClickEdit: true,
			hide: true,
		},
		{
			headerName: 'wrccomp',
			field: 'wrccomp',
			sortable: true,
			filter: true,
			flex: 1,
			minWidth: 100,
			editable: false,
			headerClass: '',
			cellClass: ['nocheckbox', 'alignC'],
			singleClickEdit: true,
			hide: true,
		},
		{
			headerName: '공장',
			field: 'wdcplnt',
			sortable: true,
			filter: true,
			flex: 1,
			minWidth: 100,
			editable: false,
			headerClass: '',
			cellClass: ['nocheckbox', 'alignL'],
			singleClickEdit: true,
			hide: false,
		},
		{
			headerName: '품번',
			field: 'wdcptno',
			sortable: true,
			filter: true,
			flex: 1,
			minWidth: 140,
			editable: false,
			headerClass: '',
			cellClass: ['nocheckbox', 'alignL'],
			singleClickEdit: true,
			valueGetter: Utils.partnoGetter,
			hide: false,
		},
		{
			headerName: '품명',
			field: 'wdcptnm',
			sortable: true,
			filter: true,
			flex: 1,
			minWidth: 260,
			editable: false,
			headerClass: '',
			cellClass: ['nocheckbox', 'alignL'],
			singleClickEdit: true,
			hide: false,
		},
		{
			headerName: '사용',
			field: 'wdcflag',
			sortable: true,
			filter: true,
			flex: 1,
			minWidth: 80,
			editable: false,
			headerClass: '',
			cellClass: ['nocheckbox', 'alignC'],
			singleClickEdit: true,
			hide: false,
		},
	];

	/**
	 * Input 항목 Forcus Select
	 * @param {*} event
	 */
	const handleFocus = (event) => {
		event.target.select();
	};

const checkNum = (str) => {
		let val = str;

		if (/\D/gi.test(str)) {
			val = val.replaceAll(/\D/gi, '');
		}
		return val;
	};

	// ── 식별표 미리보기 헬퍼 함수 ──────────────────────────────────────────
	const getPreviewLrText = (val) => {
		if (!val) return '';
		const trimmed = val.trim();
		switch (trimmed) {
			case '1': return 'FL'; case '2': return 'FR';
			case '3': return 'RL'; case '4': return 'RR';
			case '5': return 'L';  case '6': return 'R';
			case '7': return '좌'; case '8': return '우';
			case 'L': return 'LH'; case 'R': return 'RH';
			default:  return trimmed;
		}
	};

	const getPreviewColor = (code) => {
		const colorMap = { B: 'blue', G: 'green', R: 'red', O: '#ff6600', X: 'rgba(0,0,0,0.7)', Y: '#FFD700', P: '#FF1493' };
		return colorMap[code] || 'black';
	};

	// 막대바(Slider) + 숫자 입력 콤포지트 컨트롤 렌더러
	const renderSliderInput = (name, val, min, max, unit, label = '', isTable = true, customWidth = '100%') => {
		const allowDecimal = name === 'wdcpry1' || name === 'wdcpry2';
		const numVal = allowDecimal ? (parseFloat(val) || 0) : (parseInt(val, 10) || 0);
		return (
			<div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: customWidth, minWidth: 0 }}>
				{label && <span style={{ color: '#475569', fontWeight: 'bold', whiteSpace: 'nowrap', fontSize: isTable ? '12px' : '10px', flexShrink: 0 }}>{label}:</span>}
				<input
					type="range"
					name={name}
					min={min}
					max={max}
					step={allowDecimal ? 0.5 : 1}
					value={numVal}
					onChange={onChange}
					className="k-slider"
					style={{
						flex: '1 1 auto',
						minWidth: '35px',
						maxWidth: isTable ? '140px' : '110px',
						height: isTable ? '5px' : '4px',
						cursor: 'pointer',
						accentColor: '#334155'
					}}
				/>
				<input
					className="k_inputChkNumR"
					name={name}
					value={allowDecimal ? String(val ?? '') : checkNum(String(val ?? ''))}
					onChange={onChange}
					onFocus={handleFocus}
					maxLength={allowDecimal ? 5 : 3}
					style={{
						width: isTable ? '38px' : '34px',
						height: isTable ? '24px' : '22px',
						textAlign: 'center',
						fontSize: isTable ? '12px' : '11px',
						fontWeight: 'bold',
						color: '#0f172a',
						border: '1px solid #94a3b8',
						borderRadius: '4px',
						backgroundColor: '#ffffff',
						boxSizing: 'border-box',
						flexShrink: 0
					}}
				/>
				{unit && <b style={{ fontSize: isTable ? '11px' : '9px', color: '#334155', whiteSpace: 'nowrap', flexShrink: 0 }}>{unit}</b>}
			</div>
		);
	};

	// 색상 Select 박스 렌더러
	const renderColorSelect = (name, val, isTable = true) => (
		<select
			className="k_combo"
			name={name}
			value={val || 'B'}
			onChange={onChange}
			style={{
				width: '100%',
				height: isTable ? '26px' : '22px',
				border: '1px solid #cbd5e1',
				borderRadius: '4px',
				padding: '1px 4px',
				fontSize: isTable ? '11px' : '10px',
				fontWeight: 'bold',
				backgroundColor: '#ffffff',
				color: getPreviewColor(val || 'B'),
				cursor: 'pointer'
			}}
		>
			<option value="B" style={{ color: 'blue', fontWeight: 'bold' }}>파랑</option>
			<option value="R" style={{ color: 'red', fontWeight: 'bold' }}>빨강</option>
			<option value="G" style={{ color: 'green', fontWeight: 'bold' }}>초록</option>
			<option value="O" style={{ color: '#ff6600', fontWeight: 'bold' }}>주황</option>
			<option value="X" style={{ color: 'black', fontWeight: 'bold' }}>검정</option>
			<option value="P" style={{ color: '#FF1493', fontWeight: 'bold' }}>핑크</option>
		</select>
	);

	const getPreviewBgStyle = (bgClass) => {
		switch (bgClass) {
			case 'bg-yellow': return { background: 'yellow', color: '#000' };
			case 'bg-purple': return { background: '#a34ca3e3', color: '#000' };
			case 'bg-green':  return { background: '#99e599', color: '#000' };
			default:          return { background: 'transparent', color: '#000' };
		}
	};

	const getLabelType = (ptgb) => {
		if (!ptgb || !ptgb.trim()) return 'A';
		const c = ptgb.trim().charAt(0).toUpperCase();
		if (c === 'B') return 'B';
		if (c === 'C') return 'C';
		return 'A';
	};

	const renderLabelPreview = (customData = null) => {
		console.log("idata>>>>>>>>>>>>")
		console.log(idata)
		const target = customData || idata;
		const ff = '"HY견고딕", "HYGothic-Medium", "맑은 고딕", Malgun Gothic, Gulim, 굴림체, sans-serif';
		const fw = 'bold';
		const lType = getLabelType(target.wdcptgb);
		const lrVal = (target.wdcckgb || '').trim();
		const lrText = getPreviewLrText(lrVal);
		const isLhRh = (lrText === 'LH' || lrText === 'RH');

		// wdccklg: 'L'=크게(LARGE), 'S'=작게(SMALL), 미설정 = 크기 미지정(LH/RH 대형 모드 비활성)
		const currentLrSizeMode = (target.wdccklg || '').trim() === 'L' ? 'LARGE' : 'SMALL';
		// wrcbgndT: 'Y'=노랑, 그 외=없음 / wrcbgnd2B: 'P'=보라, 'G'=초록, 그 외=없음
		const currentMidBg = (target.wrcbgndT || 'N') === 'Y' ? 'bg-yellow' : 'bg-none';
		const currentBotBg = (
			(target.wrcbgnd2B || 'N') === 'P' ? 'bg-purple' :
			(target.wrcbgnd2B || 'N') === 'G' ? 'bg-green' : 'bg-none'
		);

		const isLargeMode = isLhRh && currentLrSizeMode === 'LARGE';
		const showSmallLr = Boolean(lrText) && !isLargeMode;
		const showLrCircle = showSmallLr && (lType === 'C' || currentMidBg === 'bg-yellow');
		const subPrint = parseSubPrintValue(target.wrcpsub);
		const hasSubPrint = Boolean(subPrint.text);

		// 색상 조건:
		// - LARGE 모드일 때: LH 이면 blue, 아니면 red
		// - 일반(circle-wrapper)일 때: "좌" 또는 "L" 이면 red, 아니면 blue
		const lrColor = (() => {
			if (isLargeMode) return (lrText === 'LH') ? 'blue' : 'red';
			if (lType === 'B') return (lrText === 'RH' || lrText === 'R' || lrText === '우') ? 'red' : 'blue';
			return (lrText === '좌' || lrText === 'L') ? 'red' : 'blue';
		})();

		const processNo = [target.wdcshop1, target.wdcline1, target.wdcaspr1, target.wdcrack1].filter(Boolean).join('-');
		const hpcText   = [target.wdccarc, target.wdcalct, target.wdcdlgt].filter(Boolean).join(' ');

		// 필드 매핑 (실제 DB 컬럼명 기준)
		const regnVal = target.wdcregn || '';
		const plntVal = target.wdcplnt || '';
		const carcVal = target.wdccarc || '';
		const gateVal = target.wdcgate || '';
		const ptnoVal = target.wdcptno || '';
		const ptnmVal = target.wdcptnm || '';
		const npdtVal = target.wdcnpdt || '';
		const vnmVal  = target.wdcvnm  || '';
		const vnt1Val = target.wdcvnt1 || '';
		const isRhdApplied = String(target.wdcrthd || '').trim().toUpperCase() === 'Y';
		const isLhdApplied = String(target.wdclthd || '').trim().toUpperCase() === 'Y';
		// 두 값이 모두 Y인 비정상 데이터에서도 wdcrthd의 RHD 표시를 우선한다.
		const handleText = isRhdApplied ? 'RHD' : (isLhdApplied ? 'LHD' : '');
		const containerVal = target.wdccase || target.wdccno || '';
		const assemblyCode = target.wdcprcd || '';
		const specVal = target.wdcspec || '';
		const donoVal = target.wdcdono || '';
		const procVal = processNo || '';
		const hpcVal  = hpcText || '';
		const kornVal = target.wdckorn || '';
		const ptnoDisp = ptnoVal.length >= 5 ? ptnoVal.substr(0, 5) + '-' + ptnoVal.substr(5) : ptnoVal;

		const midBgStyle = getPreviewBgStyle(currentMidBg);
		const botBgStyle = getPreviewBgStyle(currentBotBg);
		const t27 = parseFloat(target.wdcpry1) || 0;
		const t32 = parseFloat(target.wdcpry2) || 0;
		const maxTop = lType === 'A' ? 96 : lType === 'B' ? 64 : 49;
		// 기존 미리보기의 중앙/하단 색상 영역 위치는 유지한다.
		const midLeadHeight = lType === 'C' ? '0' : '1mm';
		const barcodeTopSpacerHeight = lType === 'A' ? '1mm' : lType === 'B' ? '0.6mm' : '0';

		const paperStyle = lType === 'A'
			? { width: '140mm', height: '97mm', padding: '8mm' }
			: lType === 'B'
			? { width: '140mm', height: '64.5mm', padding: '7mm 8.5mm' }
			: { width: '70mm', height: '50mm', padding: '15mm 12.6mm' };

		const lhdFontSize = lType === 'C' ? '25pt' : '27pt';
		const largeLrFontSize = lType === 'A' ? '70pt' : lType === 'B' ? '53pt' : '35pt';
		const subPrintFontSize = lType === 'A' ? '66pt' : lType === 'B' ? '49pt' : '31pt';
		const subPrintTextStroke = lType === 'A' ? undefined : '0.2px currentColor';
		const subPrintGap = lType === 'C' ? '0.5mm' : '1mm';
		const subPrintRight = lType === 'B' ? '2mm' : '1mm';
		const subPrintContainerTransform = lType === 'B'
			? 'translateY(-1.5mm)'
			: lType === 'C' ? 'translateY(-2mm)' : undefined;
		const subPrintTextTransform = lType === 'A' ? 'translate(2mm, -1.5mm)' : 'translateY(-1mm)';
		const largeLrTextTransform = lType === 'A' ? 'translateY(-1.5mm)' : 'translateY(-1mm)';
		const assemblyCodeLeft = lType === 'C' ? '38mm' : '66.5mm';
		const assemblyCodeFontSize = assemblyCode.replace(/\s/gi, '').length > 4
			? (lType === 'A' ? '38px' : lType === 'B' ? '24px' : '16px')
			: (lType === 'A' ? '44pt' : lType === 'B' ? '30pt' : '20pt');
		const partnoSize = lType === 'A'
			? (ptnoVal.trim().length > 11 ? '23pt' : '26pt')
			: lType === 'B' ? (ptnoVal.trim().length > 11 ? '23pt' : '24pt') : '14pt';
		const partnmSize = lType === 'A'
			? getAdaptiveFontSize(ptnmVal, 20, 23)
			: lType === 'B' ? getAdaptiveFontSize(ptnmVal, 22, 19) : getAdaptiveFontSize(ptnmVal, 11, 15);
		const quantityFontSize = lType === 'A' ? '27pt' : lType === 'B' ? '26pt' : '14pt';
		const smallLrFontSize = lType === 'A'
			? (lrText.length > 1 ? '28pt' : '44pt')
			: lType === 'B' ? '28pt' : '18pt';
		const smallLrCircleSize = lType === 'A' ? '65px' : lType === 'B' ? '43px' : '24px';
		const partNameLeftSpace = lType === 'C' ? '9.5mm' : '19mm';
		const partNameWidth = lType === 'A' ? '104mm' : lType === 'B' ? '111mm' : '43.5mm';
		const smallLrWidth = lType === 'A' ? '15mm' : lType === 'B' ? '8mm' : '10mm';
		const barcodePreviewZIndex = 30000;
		const dualPrintPreviewZIndex1 = 13;
		const dualPrintPreviewZIndex2 = lType === 'C' ? 12 : 13;
		const subPrintPreviewZIndex = 14;
		// 실제 인쇄와 같은 31자리 코드 및 bwip-js 옵션을 사용해 바코드 높이/비율을 맞춘다.
		const previewBarcodeValue = `${String(vnt1Val || '0000').slice(0, 4).padEnd(4, ' ')}${String(ptnoVal || 'PREVIEW').slice(0, 15).padEnd(15, ' ')}00001   0000`;
		const barcodePreview = lType === 'A'
			? <CustomDataMatrix val={previewBarcodeValue} height={12.9} bcid="code128" scale={1} />
			: <CustomDataMatrix val={previewBarcodeValue} height={12} bcid="code128" scale={0.5} width="100%" />;
		const barcodePreviewContent = lType === 'C'
			? <>
				<div style={{ width: '1mm' }} />
				<div style={{ width: '7mm' }} />
				<div style={{ width: '1.5mm' }} />
				<div style={{ position: 'relative', zIndex: barcodePreviewZIndex, flex: '1 1 60mm', height: '100%', overflow: 'hidden' }}>{barcodePreview}</div>
				<div style={{ flex: '1 1 1mm' }} />
				<div style={{ flex: '1 1 1mm' }} />
			</>
			: <>
				<div style={{ width: '1mm' }} />
				<div style={{ flex: lType === 'A' ? '1 1 25mm' : '1 1 10mm' }} />
				<div style={{ position: 'relative', zIndex: barcodePreviewZIndex, textAlign: 'center', width: lType === 'B' ? '100%' : undefined, height: '100%', overflow: 'hidden', flex: '1 1 119mm' }}>{barcodePreview}</div>
				<div style={{ flex: lType === 'A' ? '1 1 1mm' : '1 1 8mm' }} />
				<div style={{ flex: '1 1 1mm' }} />
				<div style={{ flex: '1 1 1mm' }} />
			</>;

		const mkRow = (h, children, extra = {}) => (
			<div style={{ display: 'flex', flexFlow: 'row nowrap', width: '100%', height: h, ...extra }}>
				{children}
			</div>
		);

		return (
			<div style={{ ...paperStyle, background: '#fff', border: '1px dashed #94a3b8', position: 'relative', boxSizing: 'content-box', display: 'inline-block', boxShadow: '0 4px 12px rgba(0,0,0,0.18)', fontFamily: ff }}>
				<div style={{ width: '100%', height: '100%', border: '1.5px solid #000', position: 'relative', background: '#fff', overflow: 'hidden' }}>
					<div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'visible', zIndex: 200 }}>
						{/* 이중인쇄 overlay 1 */}
						{target.wdclbl1 && t27 <= maxTop && (
							<div style={{ position: 'absolute', fontFamily: 'HY견고딕, sans-serif', fontWeight: fw, whiteSpace: 'nowrap', zIndex: dualPrintPreviewZIndex1, color: getPreviewColor(target.wdccol1), fontSize: (target.wdcsiz1 || '20') + 'pt', left: (target.wdcprx1 || '0') + 'mm', top: t27 + 'mm' }}>
								{target.wdclbl1}
							</div>
						)}
						{/* 이중인쇄 overlay 2 */}
						{target.wdclbl2 && t32 <= maxTop && (
							<div style={{ position: 'absolute', fontFamily: 'HY견고딕, sans-serif', fontWeight: fw, whiteSpace: 'nowrap', zIndex: dualPrintPreviewZIndex2, color: getPreviewColor(target.wdccol2), fontSize: (target.wdcsiz2 || '20') + 'pt', left: (target.wdcprx2 || '0') + 'mm', top: t32 + 'mm' }}>
								{target.wdclbl2}
							</div>
						)}

						{/* 1: spacer */}
						{mkRow('1mm', null)}

						{/* 2: 지역 + 회사명 (7cells = 63mm offset) */}
						{mkRow(lType === 'A' ? '8mm' : lType === 'B' ? '5mm' : '3.5mm',
							<>
								<div style={{ flex: lType === 'C' ? '0 0 32mm' : '0 0 63mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 12mm' : '1 1 27mm', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: lType === 'C' ? '6pt' : '14pt', fontWeight: fw }}>{regnVal || '서울'}</div>
								<div style={{ flex: lType === 'C' ? '0 0 24mm' : '1 1 48mm', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: lType === 'C' ? '6pt' : '11pt', fontWeight: fw }}>현대자동차(주)/기아(주)ⓡ</div>
							</>
						)}

						{/* 3: 공장 + 차종 + 납품장소 (3cells = 19mm offset) */}
						{mkRow(lType === 'C' ? '4mm' : lType === 'B' ? '5mm' : '8mm',
							<>
								<div style={{ flex: lType === 'C' ? '0 0 9.5mm' : '0 0 19mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 15mm' : '1 1 30mm', display: 'flex', alignItems: 'center', fontSize: lType === 'C' ? '11pt' : lType === 'B' ? '15pt' : '20pt', fontWeight: fw }}>{plntVal}</div>
								<div style={{ flex: lType === 'C' ? '0 0 7.5mm' : '1 1 14mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 12mm' : '1 1 27mm', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: lType === 'A' ? '16pt' : lType === 'B' ? '13pt' : '6pt', fontWeight: fw }}>{carcVal}</div>
								<div style={{ flex: lType === 'C' ? '0 0 9mm' : '1 1 18mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 15mm' : '1 1 30mm', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: lType === 'A' ? '16pt' : lType === 'B' ? '13pt' : '8pt', fontWeight: fw }}>{gateVal}</div>
							</>
						)}

						{/* 4: 품번 + 수량 (C타입은 실제 70mm 라벨 열 너비 적용) */}
						{mkRow(lType === 'C' ? '6.5mm' : lType === 'B' ? '8mm' : '12mm',
							<>
								<div style={{ flex: lType === 'C' ? '0 0 9.5mm' : '0 0 19mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 39.5mm' : '1 1 81mm', display: 'flex', alignItems: 'center', fontSize: partnoSize, fontWeight: fw, overflow: 'hidden', whiteSpace: 'nowrap' }}>
									{ptnoDisp || '---'}
								</div>
								<div style={{ flex: lType === 'C' ? '0 0 5.5mm' : '1 1 8mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 13.5mm' : '1 1 30mm', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: quantityFontSize, fontWeight: fw }}>1</div>
								{lType === 'C' && <div style={{ flex: '0 0 2mm' }} />}
							</>
						)}

						{/* 5: 영문품명 + LR 아이콘 (3cells = 19mm offset) */}
						{mkRow(lType === 'C' ? '6.5mm' : lType === 'B' ? '8mm' : '14mm',
							<>
								<div style={{ flex: `0 0 ${partNameLeftSpace}` }} />
								<div style={{ flex: `0 1 ${partNameWidth}`, display: 'flex', alignItems: 'center', fontSize: partnmSize, fontWeight: fw, overflow: 'hidden', whiteSpace: 'nowrap' }}>
									{ptnmVal || '---'}
								</div>
								{showSmallLr && (
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: smallLrWidth, flex: `0 0 ${smallLrWidth}`, position: 'relative', transform: lType === 'B' ? 'translateY(1.5mm)' : undefined }}>
										{showLrCircle && <div style={{ position: 'absolute', background: 'yellow', borderRadius: '50%', width: smallLrCircleSize, height: smallLrCircleSize, zIndex: 0 }} />}
										{lrText && (
											<span style={{ position: 'relative', zIndex: 1, fontSize: smallLrFontSize, fontWeight: fw, color: lrColor, fontFamily: ff }}>
												{lrText}
											</span>
										)}
									</div>
								)}
							</>
						)}

						{/* 중앙 강조 영역 (mid bg - 노랑 배경) */}
						<div style={{ position: 'relative', ...midBgStyle }}>
							<div style={{ display: 'flex', width: '100%', height: lType === 'C' ? '0px' : lType === 'B' ? '0.7mm' : '1mm', position: 'relative', ...midBgStyle }}>
								{(hasSubPrint || isLargeMode) && (
									<div
										style={{
											position: 'absolute',
											right: subPrintRight,
											fontFamily: ff,
											fontWeight: 'normal',
											zIndex: subPrintPreviewZIndex,
											lineHeight: '0.3',
											display: 'flex',
											alignItems: 'baseline',
											gap: subPrintGap,
											transform: subPrintContainerTransform
										}}
									>
										{hasSubPrint && (
											<span style={{ color: subPrint.cssColor, fontFamily: ff, fontWeight: 'normal', WebkitTextStroke: subPrintTextStroke, fontSize: subPrintFontSize, display: 'inline-block', flexShrink: 0, whiteSpace: 'nowrap', transform: subPrintTextTransform }}>
												{subPrint.text}
											</span>
										)}
										{isLargeMode && (
											<span style={{ color: lrColor, fontSize: largeLrFontSize, fontWeight: fw, display: 'inline-block', transform: largeLrTextTransform }}>{lrText}</span>
										)}
									</div>
								)}
							</div>
							<div style={{ display: 'flex', width: '100%', height: midLeadHeight, ...midBgStyle }} />
							<div style={{ display: 'flex', width: '100%', height: lType === 'B' ? '4mm' : '5mm', alignItems: 'center', ...midBgStyle }}>
								<div style={{ flex: lType === 'A' ? '0 0 1mm' : '0 0 2mm' }} />
								<div style={{ flex: lType === 'A' ? '1 1 41mm' : lType === 'B' ? '1 1 39mm' : '1 1 19mm', fontSize: lType === 'C' ? '10pt' : (kornVal.length > 7 ? '13pt' : '27pt'), fontWeight: fw, overflow: 'hidden', whiteSpace: 'nowrap' }}>
									{lType === 'C' ? (kornVal.length > 7 ? kornVal.substr(0, 7) : '') : (kornVal.length > 7 ? kornVal.substr(0, 10) : kornVal)}
								</div>
								<div style={{ flex: lType === 'C' ? '1 1 39mm' : '1 1 54mm', fontSize: lType === 'C' ? '9pt' : '13pt', fontWeight: fw, whiteSpace: 'nowrap' }}>
									{(plntVal === '1031' || plntVal === '1072' || plntVal === '1076' || plntVal === '1083') ? '적입중량:' : ''}
								</div>
								<div style={{ flex: lType === 'C' ? '1 1 14mm' : '1 1 42mm', fontSize: lType === 'C' ? '10pt' : '21pt', fontWeight: fw, overflow: 'hidden', whiteSpace: 'nowrap' }}>
									{specVal}
								</div>
							</div>
							{lType !== 'C' && (
								<div style={{ display: 'flex', width: '100%', height: lType === 'A' ? '5mm' : '4mm', alignItems: 'center', ...midBgStyle }}>
									<div style={{ flex: lType === 'A' ? '0 0 1mm' : '0 0 2mm' }} />
									<div style={{ flex: lType === 'A' ? '1 1 138mm' : '1 1 136mm', fontSize: lType === 'A' ? '13pt' : '12pt', fontWeight: fw, overflow: 'hidden', whiteSpace: 'nowrap' }}>
										{kornVal.length > 7 ? kornVal.substr(10) : ''}
									</div>
								</div>
							)}
						</div>

						{/* spacer */}
						{mkRow(barcodeTopSpacerHeight, null)}

						{/* 바코드 */}
						{mkRow(lType === 'C' ? '6mm' : lType === 'B' ? '8mm' : '10mm',
							barcodePreviewContent,
							{ position: 'relative' }
						)}

						{/* spacer */}
						{mkRow(lType === 'B' ? '0.7mm' : '1mm', null)}

						{/* 하단 강조 영역 (bot bg - 보라 배경) */}
						{/* Row 11: 납품일자, 업체코드, 업체명 */}
						{mkRow(lType === 'C' ? '4mm' : lType === 'B' ? '5mm' : '8mm',
							<>
								<div style={{ flex: lType === 'C' ? '0 0 11mm' : '0 0 22mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 13.5mm' : '0 0 27mm', display: 'flex', alignItems: 'center', fontSize: lType === 'C' ? '6pt' : '12pt', fontWeight: fw, color: '#000' }}>{npdtVal}</div>
								<div style={{ flex: lType === 'C' ? '0 0 10.5mm' : '0 0 17mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 9mm' : '0 0 15mm', display: 'flex', alignItems: 'center', fontSize: lType === 'C' ? '6pt' : '12pt', fontWeight: fw, color: '#000' }}>{vnt1Val}</div>
								<div style={{ flex: lType === 'C' ? '0 0 24mm' : '0 0 57mm', display: 'flex', alignItems: 'center', fontSize: lType === 'C' ? '6pt' : '12pt', fontWeight: fw, color: '#000' }}>{vnmVal}</div>
								<div style={{ flex: '0 0 2mm' }} />
							</>,
							botBgStyle
						)}

						{/* Row 12: 공정NO + 발주번호 + 핸들(LHD/RHD) (left: 66.5mm) */}
						{mkRow(lType === 'C' ? '4mm' : lType === 'B' ? '5mm' : '8mm',
							<>
								<div style={{ flex: '0 0 1mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 8.5mm' : '0 0 18mm', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontSize: lType === 'C' ? '6pt' : '11pt', fontWeight: lType === 'C' ? fw : 'normal', color: '#000', whiteSpace: 'nowrap' }}>공정NO</div>
								<div style={{ flex: lType === 'C' ? '0 0 1.5mm' : '0 0 3mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 13.5mm' : '0 0 27mm', display: 'flex', alignItems: 'center', fontSize: lType === 'A' ? '12pt' : lType === 'B' ? '11pt' : '9pt', fontWeight: fw, color: '#000', whiteSpace: 'nowrap' }}>{procVal}</div>
								<div style={{ flex: lType === 'C' ? '0 0 9mm' : '0 0 17mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 34.5mm' : '0 0 45mm', display: 'flex', alignItems: 'center', fontSize: lhdFontSize, fontWeight: fw, color: '#000' }}>{handleText}</div>
								{lType !== 'C' && <div style={{ flex: '0 0 27mm', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12pt', fontWeight: fw, color: '#000' }}>{donoVal}</div>}
								<div style={{ flex: '0 0 2mm' }} />
								{assemblyCode && (
									<div style={{ position: 'absolute', left: assemblyCodeLeft, fontFamily: ff, fontSize: assemblyCodeFontSize, fontWeight: fw, color: '#000', zIndex: 15 }}>
										{assemblyCode}
									</div>
								)}
							</>,
							{ ...botBgStyle, position: 'relative', display: 'flex', alignItems: 'center' }
						)}

						{/* Row 13: HPC */}
						{mkRow(lType === 'C' ? '4mm' : lType === 'B' ? '5mm' : '8mm',
							<>
								<div style={{ flex: '0 0 1mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 8.5mm' : '0 0 18mm', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontSize: lType === 'C' ? '6pt' : '11pt', fontWeight: lType === 'C' ? fw : 'normal', color: '#000' }}>HPC</div>
								<div style={{ flex: lType === 'C' ? '0 0 1.5mm' : '0 0 3mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 13.5mm' : '0 0 27mm', display: 'flex', alignItems: 'center', fontSize: lType === 'C' ? '9pt' : '12pt', fontWeight: fw, color: '#000' }}>{hpcVal}</div>
							</>,
							botBgStyle
						)}

						{/* Row 14: 바코드 문자열 영역 + 용기코드 */}
						{mkRow(lType === 'A' ? '6mm' : lType === 'B' ? '4mm' : '3.5mm',
							<>
								<div style={{ flex: lType === 'C' ? '0 0 11.5mm' : '0 0 23mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 29.5mm' : '0 0 68mm' }} />
								<div style={{ flex: lType === 'C' ? '1 1 auto' : '0 0 20mm' }} />
								<div style={{ flex: lType === 'C' ? '0 0 8mm' : '0 0 27mm', display: 'flex', alignItems: 'center', justifyContent: lType === 'C' ? 'flex-end' : 'center', fontSize: lType === 'C' ? '6pt' : '12pt', fontWeight: fw, color: '#000' }}>{containerVal}</div>
							</>
						)}
					</div>
				</div>
			</div>
		);
	};

	// ── 이중인쇄 샘플러 헬퍼 함수들 ──────────────────────────────────────────
	const SAMPLER_COLORS = { B: 'blue', R: 'red', G: 'green', O: '#ff6600', Y: '#FFD700', P: '#FF1493', X: 'rgba(0,0,0,0.7)' };
	const getSamplerPresetName = (preset, idx) => {
		const presetName = preset.wrcgbnm || preset.WRCGBNM || preset.PRESET_NM || preset.presetNm;
		return String(presetName || '').trim() || `샘플 ${idx + 1}`;
	};

	/**
	 * 샘플러 카드용 미리보기 썸네일 렌더링 (좌측 미리보기 컴포넌트와 100% 동일한 비주얼)
	 */
	const buildSamplerCardThumbnail = (p) => {
		// 샘플 카드 썸네일은 preset 고유 값 + 레이아웃용 필드(품번/품명 등)만 사용.
		// idata 전체를 spread하면 사용자가 폼에서 수정 중인 wdccklg/wrcbgndT 등이
		// 실시간으로 샘플 카드에 반영되는 문제가 생기므로, 레이아웃 전용 필드만 가져옴.
		const bgRaw = p.wrcbgnd ? String(p.wrcbgnd).padEnd(2, 'N') : 'NN';
		const bgT = p.wrcbgndT || bgRaw.charAt(0) || 'N';
		const bgB = p.wrcbgnd2B || bgRaw.charAt(1) || 'N';
		const customData = {
			// ── 레이아웃 표시용 필드 (idata에서만 참조) ──
			wdcptno: (idata.wdcptno || '').trim(),
			wdcptnm: (idata.wdcptnm || '').trim(),
			wdckorn: (idata.wdckorn || '').trim(),
			wdcplnt: idata.wdcplnt || '',
			wdcgate: idata.wdcgate || '',
			wdccarc: idata.wdccarc || '',
			wdcspec: idata.wdcspec || '',
			wdcshop1: idata.wdcshop1 || '',
			wdcline1: idata.wdcline1 || '',
			wdcaspr1: idata.wdcaspr1 || '',
			wdcrack1: idata.wdcrack1 || '',
			wdcalct: idata.wdcalct || '',
			wdcdlgt: idata.wdcdlgt || '',
			wdcptgb: samplerActiveType,
			// L/R 구분 - preset 우선, 없으면 idata
			wdcckgb: p.wdcckgb !== undefined && p.wdcckgb !== null ? p.wdcckgb : (idata.wdcckgb || ''),
			// L/R 크기 - WRTDUPX의 WRCCKLG 값만 사용한다.
			wdccklg: p.wdccklg !== undefined && p.wdccklg !== null ? p.wdccklg : '',
			// 이중인쇄 1 - preset 값 전용
			wdclbl1: p.wdclbl1 || '',
			wdcprx1: String(parseFloat(p.wdcprx1) || 0),
			wdcpry1: String(parseFloat(p.wdcpry1) || 0),
			wdccol1: p.wdccol1 || 'B',
			wdcsiz1: String(parseFloat(p.wdcsiz1) || 0),
			// 이중인쇄 2 - preset 값 전용
			wdclbl2: p.wdclbl2 || '',
			wdcprx2: String(parseFloat(p.wdcprx2) || 0),
			wdcpry2: String(parseFloat(p.wdcpry2) || 0),
			wdccol2: p.wdccol2 || 'B',
			wdcsiz2: String(parseFloat(p.wdcsiz2) || 0),
			// 핸들 - preset 값 전용
			wdcrthd: p.wdcrthd || 'N',
			wdclthd: p.wdclthd || 'N',
			wrcpsub: p.wrcpsub || '',
			// 배경색 - preset 값 전용 (사용자 수정값 차단)
			wrcbgnd: bgT + bgB,
			wrcbgndT: bgT,
			wrcbgnd2B: bgB,
		};

		const lType = samplerActiveType;
		const scaleVal = lType === 'C' ? 0.52 : lType === 'B' ? 0.37 : 0.35;
		// 축소된 라벨의 전체 높이(용지 padding/border 포함)만큼 표시 영역을 확보한다.
		// 라벨 내부 위치와 이중인쇄 좌표는 변경하지 않는다.
		const containerHeight = lType === 'C' ? '164px' : lType === 'B' ? '116px' : '156px';

		return (
			<div style={{
				width: '100%',
				height: containerHeight,
				overflow: 'hidden',
				position: 'relative',
				background: '#ffffff',
				borderBottom: '1px solid #e2e8f0',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'flex-start',
				paddingTop: '2px',
			}}>
				<div style={{
					transform: `scale(${scaleVal})`,
					transformOrigin: 'top center',
					pointerEvents: 'none',
					flexShrink: 0,
				}}>
					{renderLabelPreview(customData)}
				</div>
			</div>
		);
	};

	/**
	 * 샘플러 샘플 로드 (실제 API 전용 - Mock 데이터 완전히 제거)
	 */
	const onLoadSamplerPresets = async (plnt, type) => {
		if (!plnt) return;
		const requestSeq = ++samplerRequestSeqRef.current;
		const requestedType = getLabelType(type);

		setSamplerLoading(true);
		setSamplerPresets([]);
		setSamplerSelIdx(-1);

		try {
			const res = await fetch(
				`${SERVER_URL}/rom4h/dualprint/presets?plnt=${encodeURIComponent(plnt)}`,
				{ headers: { Authorization: token } }
			);

			if (res.ok) {
				const j = await res.json();
				if (requestSeq !== samplerRequestSeqRef.current) return;
				if (j.success && j.data) {
					console.log("j.data>>>>>>>>>>")
					console.log(j.data)
					// 공장의 A/B/C 전체 샘플 존재 여부를 확인하되, 목록에는 현재 탭의 샘플만 표시한다.
					let presetsList = [];
					if (Array.isArray(j.data)) {
						setSamplerHasAnyPresets(j.data.length > 0);
						presetsList = j.data.filter((preset) => getLabelType(preset.wdcptgb || preset.WDCPTGB) === requestedType);
					} else if (typeof j.data === 'object') {
						const allPresets = Object.values(j.data).reduce(
							(acc, value) => acc.concat(Array.isArray(value) ? value : []),
							[]
						);
						setSamplerHasAnyPresets(allPresets.length > 0);
						presetsList = j.data[requestedType] || j.data[requestedType.toLowerCase()] || [];
					}
					setSamplerPresets(Array.isArray(presetsList) ? presetsList : []);
				} else {
					setSamplerPresets([]);
					setSamplerHasAnyPresets(false);
				}
			} else {
				if (requestSeq === samplerRequestSeqRef.current) {
					setSamplerPresets([]);
					setSamplerHasAnyPresets(false);
				}
			}
		} catch (e) {
			console.error('onLoadSamplerPresets API Error:', e);
			if (requestSeq === samplerRequestSeqRef.current) {
				setSamplerPresets([]);
				setSamplerHasAnyPresets(false);
			}
		} finally {
			if (requestSeq === samplerRequestSeqRef.current) setSamplerLoading(false);
		}
	};

	const onChangeSamplerType = (type) => {
		setSamplerActiveType(type);
		setSamplerSelIdx(-1);
		if (idata.wdcplnt) {
			onLoadSamplerPresets(idata.wdcplnt, type);
		} else {
			samplerRequestSeqRef.current += 1;
			setSamplerLoading(false);
			setSamplerPresets([]);
			setSamplerHasAnyPresets(false);
		}
	};

	/**
	 * 샘플 선택 전 기존 설정값 백업 스냅샷 저장
	 */
	const captureInitialSettings = (currentData = idata) => {
		const bgndRaw = currentData.wrcbgnd || 'NN';
		initialDualPrintStateRef.current = {
			wdcptgb: currentData.wdcptgb || '',
			wdclbl1: currentData.wdclbl1 || '',
			wdcprx1: currentData.wdcprx1 !== undefined && currentData.wdcprx1 !== null ? String(currentData.wdcprx1) : '0',
			wdcpry1: currentData.wdcpry1 !== undefined && currentData.wdcpry1 !== null ? String(currentData.wdcpry1) : '0',
			wdccol1: currentData.wdccol1 || 'B',
			wdcsiz1: currentData.wdcsiz1 !== undefined && currentData.wdcsiz1 !== null ? String(currentData.wdcsiz1) : '0',

			wdclbl2: currentData.wdclbl2 || '',
			wdcprx2: currentData.wdcprx2 !== undefined && currentData.wdcprx2 !== null ? String(currentData.wdcprx2) : '0',
			wdcpry2: currentData.wdcpry2 !== undefined && currentData.wdcpry2 !== null ? String(currentData.wdcpry2) : '0',
			wdccol2: currentData.wdccol2 || 'B',
			wdcsiz2: currentData.wdcsiz2 !== undefined && currentData.wdcsiz2 !== null ? String(currentData.wdcsiz2) : '0',

			wdcckgb: currentData.wdcckgb !== undefined && currentData.wdcckgb !== null ? currentData.wdcckgb : ' ',
			wdccklg: currentData.wdccklg !== undefined && currentData.wdccklg !== null ? currentData.wdccklg : '',

			wdcrthd: currentData.wdcrthd || 'N',
			wdclthd: currentData.wdclthd || 'N',
			wrcpsub: currentData.wrcpsub || '',

			wrcbgnd: bgndRaw,
			wrcbgndT: currentData.wrcbgndT || bgndRaw.charAt(0) || 'N',
			wrcbgnd2B: currentData.wrcbgnd2B || bgndRaw.charAt(1) || 'N',
		};
	};

	/**
	 * 초기화 클릭 → 샘플 선택 전 기존 설정값으로 100% 복원
	 */
	const onResetSamplerDualPrint = () => {
		setSamplerSelIdx(-1);
		if (initialDualPrintStateRef.current) {
			setData((prev) => ({
				...prev,
				...initialDualPrintStateRef.current,
			}));
		}
	};

	/**
	 * 샘플러 샘플 카드 클릭 → 사용자정의 필드 즉시 적용 (실제 DB 컬럼명 전용)
	 */
	const onApplySamplerPreset = (preset, idx) => {
		// 이미 선택된 샘플을 다시 클릭하면 선택 해제 및 기존 설정 복원
		if (samplerSelIdx === idx) {
			onResetSamplerDualPrint();
			return;
		}

		// 첫 선택 시 백업 스냅샷이 없으면 현재 설정값 스냅샷 백업
		if (!initialDualPrintStateRef.current) {
			captureInitialSettings(idata);
		}

		setSamplerSelIdx(idx);
		const newData = { ...idata };

		// 탭 전환만으로는 기존 미리보기 타입을 유지하고,
		// 샘플을 실제 선택한 시점에 선택 탭의 용지 타입(A/B/C)을 적용한다.
		newData['wdcptgb'] = samplerActiveType;

		// 이중인쇄 1
		newData['wdclbl1'] = preset.wdclbl1 || '';
		newData['wdcprx1'] = String(parseFloat(preset.wdcprx1) || 0);
		newData['wdcpry1'] = String(parseFloat(preset.wdcpry1) || 0);
		newData['wdccol1'] = preset.wdccol1 || 'B';
		newData['wdcsiz1'] = String(parseFloat(preset.wdcsiz1) || 0);

		// 이중인쇄 2
		newData['wdclbl2'] = preset.wdclbl2 || '';
		newData['wdcprx2'] = String(parseFloat(preset.wdcprx2) || 0);
		newData['wdcpry2'] = String(parseFloat(preset.wdcpry2) || 0);
		newData['wdccol2'] = preset.wdccol2 || 'B';
		newData['wdcsiz2'] = String(parseFloat(preset.wdcsiz2) || 0);

		// L/R 구분 (wdcckgb) 및 크기 (wdccklg)
		if (preset.wdcckgb !== undefined && preset.wdcckgb !== null) {
			newData['wdcckgb'] = preset.wdcckgb;
		}

		newData['wdccklg'] = preset.wdccklg !== undefined && preset.wdccklg !== null
			? preset.wdccklg
			: '';

		// 핸들 (wdcrthd, wdclthd)
		newData['wdcrthd'] = preset.wdcrthd || 'N';
		newData['wdclthd'] = preset.wdclthd || 'N';
		newData['wrcpsub'] = preset.wrcpsub || '';

		// 배경색 (wrcbgnd, wrcbgndT, wrcbgnd2B)
		const bgVal = preset.wrcbgnd || 'YP';
		const bgRaw = String(bgVal).padEnd(2, 'N');
		const bgT = preset.wrcbgndT || bgRaw.charAt(0) || 'N';
		const bgB = preset.wrcbgnd2B || bgRaw.charAt(1) || 'N';
		newData['wrcbgnd']  = bgT + bgB;
		newData['wrcbgndT'] = bgT;
		newData['wrcbgnd2B'] = bgB;

		// Note: wdcptno, wdcptnm, wdckorn, wdcwtun, wdcvnm, wdcvnt1 등은
		// 사용자 정의(idata) 값을 유지하도록 샘플 선택 시 덮어쓰지 않음

		setData(newData);
	};

	/**
	 * 샘플러 패널 토글 + 자동 로드
	 */
	const onToggleSampler = () => {
		const next = !samplerOpen;
		samplerOpenRef.current = next;
		setSamplerOpen(next);
		setShowPreview(next); // 미리보기와 샘플러를 항상 같이 열고 닫음
		if (next) {
			// 모달을 열 때 기존 설정값 스냅샷 백업
			captureInitialSettings(idata);
			const lType = getLabelType(idata.wdcptgb);
			setSamplerActiveType(lType);
			if (idata.wdcplnt) {
				onLoadSamplerPresets(idata.wdcplnt, lType);
			} else {
				samplerRequestSeqRef.current += 1;
				setSamplerLoading(false);
				setSamplerPresets([]);
				setSamplerHasAnyPresets(false);
				setSamplerSelIdx(-1);
			}
		}
	};
	const showSamplerPresetList = samplerLoading || samplerHasAnyPresets;

	return (
		<>
			{/* Dialog FRAME */}
			<AlertDialog open={openDlg} trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

			{/* Alert FRAME */}
			<CustomAlert
				open={openAlert}
				severity={severity}
				duration={3000}
				message={msg}
				onClose={() => {
					setMessage({ openAlert: false, severity: '', msg: '조회 실패' });
				}}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			/>

			{/* Loading */}
			<Loading loading={loading} />

			{/* Ribbon Frame : 프로그램 Path 및 버튼 */}
			<Ribbon
				onInfoMsg={'수기로 입력한 데이터는 납품서 발행(출하정보전송)이 불가합니다. <br/> 수신자료관리 – 기초관리 – 자료생성(수동)에서 데이터생성 먼저 진행해 주시기 바랍니다.'}
				onSearch={onSearch}
				onSearchName={null} //조회
				onInsert={onInsert}
				onInsertName={null} //입력
				onUpdate={onUpdate}
				onUpdateName={null} //수정
				onDelete={onDelete}
				onDeleteName={null} //삭제
				onExcel={onExcel}
				onExcelName={null} //Excel
			>
				{'납입지시 > 기초관리 > '}
				<b style={{ color: '#cd5c5c', fontFamily: 'PretendardLight, NanumGothic, sans-serif' }}>ERP_품목관리</b>
			</Ribbon>

			{/* ContentXearch Frame : 검색조건 */}
			<ContentXearch optionsX={optionsX} onChange={onChange} onClick={onClick} />

			{/* Content FRAME (Data / Grid Frame) START -------------- */}
			<ContentTwo style={style}>
				{' '}
				{/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:100px */}
				<div className={'grid_type05'}>
					{/* 좌측 FRAME */}
					<div className={'grid_wrap05'}>
						{' '}
						{/* 좌측 wrap FRAME */}
						<div className="grid_area">
							{' '}
							{/* Grid area */}
							<div className="grid_cont_box" style={{ height: 'calc(100%)' }}>
								<Grid
									ref={grdRom4lMain}
									gridId={'ROM4L'} // (필수) Grid Id 정의
									columnDefs={columnDefs} // (필수) 컬럼 정의
									pagination={true} // 쪽수 매기기 여부
									paginationCsv={false} // CSV 사용구분 - pagination과 동시에 사용 필요
									paginationPageSize={'1000'} // 쪽수 1Page 당 Row수
									rowMultiSelectWithClick={true} // 멀티 클릭 가능 여부
									suppressRowClickSelection={false} // 클릭으로 선택 하는것을 방지
									rowSelection={'multiple'} // 여러개 선택 "multiple" 가능, 한개 선택할 때는 "single"
									enableRangeSelection={false}
									enableCellTextSelection={true} // cell selection drag mode
									isFirst={true} // 첫번째 컬럼 체크박스 사용여부 - ( default 체크박스 사용안함 )
									displayNo={false}
									searchApi={searchApi} // 조회
									deleteApi={deleteApi} // 삭제
									deleteRefresh={onSearch} // 삭제이후
									updateRefresh={onSearch2} // 수정이후
									onClearApi={onClearApi} // 초기화
									clearGrid={clearGrid}
									onClearGridFlag={setClearGrid}
									onCellValueChangedEvent={grdRom4lMain_onCellValueChanged}
									onRowClickEvent={grdRom4lMain_onRowClicked}
									expanded={panded}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className={'grid_type06'}>
					{/* 우측 FRAME */}
					<div className="grid_wrap06">
						{' '}
						{/* 우측 wrap FRAME */}
						<div className="grid_area" style={{ height: '100%', border: '1px solid #babfc7', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
							{/* Grid area */}
							<table className="input_box input_box01" style={{ width: '100%', tableLayout: 'fixed' }}>
								<colgroup>
									<col width="9%" />
									{/*<!-- <col width="0.1px"/> -->*/}
									<col width="12%" />
									<col width="16%" />
									<col width="15%" />
									<col width="17%" />
									<col width="13%" />
									<col width="17%" />
								</colgroup>
								<tbody>
									<tr className="standard_tr uno_tr">
										<td className="t_head t_head_do" rowSpan="9">
											D0
										</td>
										<td className="k_label13R">
											<b>
												품 번(<span className="no_point">*</span>)
											</b>
										</td>
										<td className="k_label18L">
											{/* 품번입력 */}
											<input className="k_inputChkL_M" value={idata.wdcptno} onChange={onChange} maxLength="18" name="wdcptno" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">
											<b>
												품 명(<span className="no_point">*</span>)
											</b>
										</td>
										<td className="k_label18L" colSpan="3">
											{/* 품명입력 */}
											<input className="k_inputChkL_M" value={idata.wdcptnm} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="30" name="wdcptnm" onFocus={handleFocus} />
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr uno_tr' : 'standard_tr2 uno_tr'}>
										<td className="k_label13R">대표하치장&nbsp;</td>
										<td className="k_label18L">
											{/* 대표하치장입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate} onChange={onChange} maxLength="4" name="wdcgate" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">실적구분&nbsp;</td>
										<td className="k_label18L">
											{/* 실적구분입력 */}
											<input className="k_inputChkC_M" value={idata.wdcsjgb} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="1" name="wdcsjgb" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">납품서구분&nbsp;</td>
										<td className="k_label18L">
											{/* 납품서구분입력 */}
											<input className="k_inputChkC_M" value={idata.wdcnpgb} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="1" name="wdcnpgb" onFocus={handleFocus} />
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr uno_tr' : 'standard_tr2 uno_tr'}>
										<td className="k_label13R">용기코드&nbsp;</td>
										<td className="k_label18L">
											{/* 용기코드 입력 */}
											<input className="k_inputChkL_M" value={idata.wdccase} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="7" name="wdccase" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">용기당수량&nbsp;</td>
										<td className="k_label18L">
											{/* 용기당수량 입력 */}
											<input className="k_inputChkNumR" value={idata.wdcqypc} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="13" name="wdcqypc" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">입고방식&nbsp;</td>
										<td className="k_label18L">
											{/* 입고방식 입력 */}
											<input className="k_inputChkL_M" value={idata.wdciggb} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="1" name="wdciggb" onFocus={handleFocus} />
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr uno_tr' : 'standard_tr2 uno_tr'}>
										<td className="k_label13R">효력시작일&nbsp;</td>
										<td className="k_label18L">
											{/* 효력시작일 입력 */}
											<input className="k_inputChkL" value={idata.wdcfrdt} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="2" name="wdcfrdt" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">효력종료일&nbsp;</td>
										<td className="k_label18L">
											{/* 효력종료일 입력 */}
											<input className="k_inputChkL" value={idata.wdctodt} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="2" name="wdctodt" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">검수유무&nbsp;</td>
										<td className="k_label18L">
											{/* 검수유무 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcokgb} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="1" name="wdcokgb" onFocus={handleFocus} />
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr uno_tr' : 'standard_tr2 uno_tr'}>
										<td className="k_label13R">구매문서&nbsp;</td>
										<td className="k_label18L">
											{/* 구매문서 입력 ReadyOnly */}
											<input className="k_inputChkL" value={idata.wdcdono} style={{ WIDTH: '100%' }} readOnly maxLength="1" name="wdcdono" />
										</td>
										<td className="k_label13R">품목번호&nbsp;</td>
										<td className="k_label18L">
											{/* 품목번호 입력 ReadyOnly */}
											<input className="k_inputChkL_M" value={idata.wdcdopt} style={{ WIDTH: '100%' }} readOnly maxLength="1" name="wdcdopt" />
										</td>
										<td className="k_label13R">담당자&nbsp;</td>
										<td className="k_label18L">
											{/* 담당자 입력 */}
											<input className="k_inputChkL_M" value={idata.wdccrdx} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="3" name="wdccrdx" onFocus={handleFocus} />
										</td>
									</tr>
								</tbody>
							</table>{' '}
							{/*<!-- DO 테이블 END --> */}
							<table className="input_box input_box01" style={{ width: '100%', tableLayout: 'fixed' }}>
								<colgroup>
									<col width="9%" />
									<col width="12%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
									<col width="7.7%" />
								</colgroup>
								<tbody>
									<tr className={panded === true ? 'standard_tr dos_tr' : 'standard_tr2 dos_tr'}>
										<td className="t_head t_head_do" rowSpan="12">
											DH
										</td>
										<td className="k_label13R">하치장</td>
										<td className="k_label18L">
											{/* 하치장1 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate1} onChange={onChange} maxLength="4" name="wdcgate1" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장2 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate2} onChange={onChange} maxLength="4" name="wdcgate2" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장3 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate3} onChange={onChange} maxLength="4" name="wdcgate3" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장4 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate4} onChange={onChange} maxLength="4" name="wdcgate4" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장5 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate5} onChange={onChange} maxLength="4" name="wdcgate5" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장6 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate6} onChange={onChange} maxLength="4" name="wdcgate6" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장7 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate7} onChange={onChange} maxLength="4" name="wdcgate7" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장8 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate8} onChange={onChange} maxLength="4" name="wdcgate8" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장9 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate9} onChange={onChange} maxLength="4" name="wdcgate9" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 하치장10 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgate10} onChange={onChange} maxLength="4" name="wdcgate10" onFocus={handleFocus} />
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr dos_tr' : 'standard_tr2 dos_tr'}>
										<td className="k_label13R">한글품명</td>
										<td className="k_label18L" colSpan="6">
											{/* 한글품명 입력 */}
											<input className="k_inputChkL" value={idata.wdckorn} onChange={onChange} maxLength="30" name="wdckorn" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">공급자</td>
										<td className="k_label18L" colSpan="3">
											{/* 공급자 입력 */}
											<input className="k_inputChkL_M" value={idata.wdctrst} onChange={onChange} maxLength="2" name="wdctrst" onFocus={handleFocus} />
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr dos_tr' : 'standard_tr2 dos_tr'}>
										<td className="k_label13R">공정No</td>
										<td className="k_label18L">
											{/* 공정No 1 */}
											<input className="k_inputChkL_M" value={idata.wdcshop1} onChange={onChange} maxLength="1" name="wdcshop1" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* 공정No 2 */}
											<input className="k_inputChkL_M" value={idata.wdcline1} onChange={onChange} maxLength="6" name="wdcline1" onFocus={handleFocus} />
										</td>
										<td className="k_label18L" colSpan="2">
											{/* 공정No 3 */}
											<input className="k_inputChkL_M" value={idata.wdcaspr1} onChange={onChange} maxLength="10" name="wdcaspr1" onFocus={handleFocus} />
										</td>
										<td className="k_label18L" colSpan="2">
											{/* 공정No 4 */}
											<input className="k_inputChkL_M" value={idata.wdcrack1} onChange={onChange} maxLength="3" name="wdcrack1" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">HPC</td>
										<td className="k_label18L">
											{/* HPC1 */}
											<input className="k_inputChkL_M" value={idata.wdccarc} onChange={onChange} maxLength="2" name="wdccarc" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* HPC2 */}
											<input className="k_inputChkL_M" value={idata.wdcalct} onChange={onChange} maxLength="1" name="wdcalct" onFocus={handleFocus} />
										</td>
										<td className="k_label18L">
											{/* HPC3 */}
											<input className="k_inputChkL_M" value={idata.wdcdlgt} onChange={onChange} maxLength="3" name="wdcdlgt" onFocus={handleFocus} />
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr dos_tr' : 'standard_tr2 dos_tr'}>
										<td className="k_label13R">공정&nbsp;</td>
										<td className="k_label18L" colSpan="6">
											{/* 공정 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcgjno} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="5" name="wdcgjno" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">조립코드&nbsp;</td>
										<td className="k_label18L" colSpan="3">
											{/* 조립코드 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcprcd} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="5" name="wdcprcd" onFocus={handleFocus} />
										</td>
									</tr>

									<tr className={panded === true ? 'standard_tr dos_tr' : 'standard_tr2 dos_tr'}>
										<td className="k_label13R">ALC&nbsp;</td>
										<td className="k_label18L" colSpan="6">
											{/* ALC 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcalcc} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="3" name="wdcalcc" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">납품단가&nbsp;</td>
										<td className="k_label18L" colSpan="3">
											{/* 납품단가 입력 */}
											<input
												type="text"
												className="k_inputChkL_M"
												value={checkNum(idata.wdcnppr)}
												onChange={onChange}
												style={{ WIDTH: '100%' }}
												maxLength="11"
												name="wdcnppr"
												onFocus={handleFocus}
											/>
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr dos_tr' : 'standard_tr2 dos_tr'}>
										<td className="k_label13R">LANE&nbsp;</td>
										<td className="k_label18L" colSpan="6">
											{/* LANE 입력 */}
											<input className="k_inputChkL" value={idata.wdclane} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="30" name="wdclane" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">특기&nbsp;</td>
										<td className="k_label18L" colSpan="3">
											{/* 특기 입력 */}
											<input className="k_inputChkL_M" value={idata.wdcoptn} onChange={onChange} style={{ WIDTH: '100%' }} maxLength="10" name="wdcoptn" onFocus={handleFocus} />
										</td>
									</tr>
								</tbody>
							</table>{' '}
							{/*<!-- DH 테이블 END -->*/}
							<table className="input_box input_box01" style={{ width: '100%', tableLayout: 'fixed' }}>
								<colgroup>
									<col width="9%" />
									{/*<!-- <col width="0.1px"/> -->*/}
									<col width="12%" />
									<col width="16%" />
									<col width="15%" />
									<col width="17%" />
									<col width="13%" />
									<col width="17%" />
								</colgroup>
								<tbody>
									<tr className={panded === true ? 'standard_tr tres_tr' : 'standard_tr2 tres_tr'}>
										<td className="t_head t_head_do" rowSpan="7" style={{ verticalAlign: 'middle', textAlign: 'center', padding: '6px 2px' }}>
											<style>{`
												@keyframes exclPulse {
													0%, 100% { transform: scale(1); opacity: 0.9; }
													50% { transform: scale(1.22); opacity: 1; filter: drop-shadow(0 0 6px rgba(205, 92, 92, 0.65)); }
												}
											`}</style>
											<div style={{ fontWeight: 'bold', lineHeight: '1.3', marginBottom: '6px' }}>
												사<br />용<br />자<br />정<br />의
											</div>
											{/* 샘플 보기 버튼 */}
											<button
												type="button"
												onClick={onToggleSampler}
												title="이중인쇄 미리보기 & 샘플 팝업 열기"
												style={{
													background: 'transparent',
													border: 'none',
													outline: 'none',
													cursor: 'pointer',
													padding: '4px 0 0 0',
													margin: '0 auto',
													display: 'flex',
													flexDirection: 'column',
													alignItems: 'center',
													justifyContent: 'center',
													gap: '2px',
													width: '100%',
												}}
											>
												<span style={{
													fontSize: '18px',
													fontWeight: '900',
													color: 'rgb(205, 92, 92)',
													animation: 'exclPulse 1.8s infinite ease-in-out',
													display: 'inline-block',
													lineHeight: 1,
												}}>
													!
												</span>
												<span style={{
													fontSize: '11px',
													fontWeight: 'bold',
													color: 'rgb(205, 92, 92)',
													lineHeight: '1.2',
												}}>
													샘플
												</span>
											</button>

										</td>
										<td className="k_label13R">식별표Type</td>
										<td className="k_label18L">
											<select className="k_combo" name="wdcptgb" value={idata.wdcptgb} onChange={onChange}>
												<option selected value=" "></option>
												{idata.typeList.map((element) =>
													element.comCode == idata.wdcptgb ? (
														<option key={'wdcptgb' + element.comCode} value={element.comCode} selected>
															{element.comCode + ' ' + element.text}
														</option>
													) : (
														<option key={'wdcptgb' + element.comCode} value={element.comCode}>
															{element.comCode + ' ' + element.text}
														</option>
													),
												)}
											</select>
										</td>
										<td className="k_label13R">부착면수</td>
										<td className="k_label18L">
											{/* 부착면수 입력 */}
											<input
												className="k_inputChkNumR"
												value={idata.wdcstck}
												onChange={onChange}
												maxLength="20"
												name="wdcstck"
												onFocus={handleFocus}
												readOnly={idata.wdcplnt != '1081' && idata.wdcplnt != '1082' && idata.wdcplnt != '1083' ? false : true}
											// readOnly={idata.wdcplnt != 'HK11' && idata.wdcplnt != 'HK21' && idata.wdcplnt != 'HK31' ? false : true}
											/>
										</td>

										<td className="k_label13R">지역</td>
										<td className="k_label18L">
											{/* 지역 Select */}
											<select className="k_combo" name="wdcspec" value={idata.wdcspec} onChange={onChange}>
												<option selected value=" "></option>
												{idata.wdcspecList.map((element) => (
													<option key={'wdcspec' + element.comCode} value={element.comCode}>
														{element.text}
													</option>
												))}
											</select>
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr tres_tr' : 'standard_tr2 tres_tr'}>
										<td className="k_label13R">L/R 구분</td>
										<td className="k_label18L" style={{ display: "flex", justifyContent : "space-between" }} >
											<select className="k_combo" name="wdcckgb" value={idata.wdcckgb} onChange={onChange} style={{ width : "70%", border: "0px solid rgb(229 229 229)" }}>
												{/* L/R Select */}
												<option selected value=" "></option>
												{idata.wdcckgbList.map((element) => (
													<option key={'wdcckgb' + element.comCode} value={element.comCode}>
														{element.text}
													</option>
												))}
											</select>
											<select className="k_combo" name="wdccklg" value={idata.wdccklg} onChange={onChange} style={{ width : "28%", border: "1px solid rgb(229 229 229)" }}>
												{/* L/R Select */}
												<option selected value=" "></option>
													<option key={'wdcclg'} value={"L"}>
														크게
												</option>
												<option key={'wdcclg'} value={"S"}>
														작게
													</option>
											</select>
										</td>


										<td className="k_label13R">RHD/LHD적용</td>
										<td className="k_label18L_f radio_box">
											{/* RHD Radio: value=rthd → wdcrthd=Y, wdclthd=N */}
											<label className="k_label_radio">
												<input
													checked={idata.wdcrthd === 'Y' && idata.wdclthd !== 'Y'}
													type="radio" value="rthd" name="lrthd" onChange={onChange} />
												&nbsp; <span className="radio_color">RHD</span>
											</label>
											{/* LHD Radio: value=lthd → wdcrthd=N, wdclthd=Y */}
											<label className="k_label_radio">
												<input
													checked={idata.wdclthd === 'Y' && idata.wdcrthd !== 'Y'}
													type="radio" value="lthd" name="lrthd" onChange={onChange} />
												&nbsp; <span className="radio_color">LHD</span>
											</label>
											{/* NO: wdcrthd=N, wdclthd=N */}
											<label className="k_label_radio">
												<input
													checked={idata.wdcrthd !== 'Y' && idata.wdclthd !== 'Y'}
													type="radio" value="N" name="lrthd" onChange={onChange} />
												&nbsp; <span className="radio_color">NO</span>
											</label>
										</td>
										{/* <td className="k_label18L_f radio_box">
											<label className="k_label_radio">
												<input checked={idata.wdcrthd === 'Y'} type="radio" value="Y" name="wdcrthd" onChange={onChange} />
												&nbsp; <span className="radio_color">Yes</span>
											</label>
											<label className="k_label_radio">
												<input checked={idata.wdcrthd === 'N'} type="radio" value="N" name="wdcrthd" onChange={onChange} />
												&nbsp; <span className="radio_color">No</span>
											</label>
										</td> */}



										<td className="k_label13R">사용여부</td>
										<td className="k_label18L_f radio_box">
											{/* 사용여부 Radio */}
											<label>
												<input className="k_label_radio" checked={idata.wdcflag === 'Y'} type="radio" value="Y" name="wdcflag" onChange={onChange} />
												&nbsp; <span className="radio_color">Yes</span>
											</label>
											<label>
												<input className="k_label_radio" checked={idata.wdcflag === 'N'} type="radio" value="N" name="wdcflag" onChange={onChange} />
												&nbsp; <span className="radio_color">No</span>
											</label>
											<label>
												<input className="k_label_radio" checked={idata.wdcflag === 'S'} type="radio" value="S" name="wdcflag" onChange={onChange} />
												&nbsp; <span className="radio_color">T2</span>
											</label>
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr tres_tr' : 'standard_tr2 tres_tr'}>
										<td className="k_label13R_f" colSpan="2">
											[이중인쇄 출력1설정]
										</td>
										<td className="k_label13R">내용&nbsp;</td>
										<td className="k_label18L">
											{/* 내용입력 */}
											<input className="k_inputChkL2" value={idata.wdclbl1} onChange={onChange} maxLength="25" name="wdclbl1" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">색상&nbsp;</td>
										<td className="k_label18L">
											{/* 색상 select */}
											{renderColorSelect('wdccol1', idata.wdccol1, true)}
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr tres_tr' : 'standard_tr2 tres_tr'}>
										<td className="k_label13R">폰트사이즈</td>
										<td className="k_label18L">
											{/* 폰트사이즈 입력 (막대바 + 숫자) */}
											{renderSliderInput('wdcsiz1', idata.wdcsiz1, 0, 250, 'pt', '', true)}
										</td>
										<td className="k_label13R" title="[이중인쇄 출력1설정] X좌표 : 절취선부터 mm 측정 (글자 폭에 따라 오차범위 존재 : ± 5mm)" style={{ cursor: 'pointer' }}>
											<b>X좌표</b>
										</td>
										<td className="k_label18L">
											{/* X좌표 입력 (막대바 + 숫자) */}
											{renderSliderInput('wdcprx1', idata.wdcprx1, 0, 150, '㎜', '', true)}
										</td>
										<td className="k_label13R" title="[이중인쇄 출력1설정] Y좌표 : 절취선부터 mm 측정" style={{ cursor: 'pointer' }}>
											<b>Y좌표</b>
										</td>
										<td className="k_label18L">
											{/* Y좌표 입력 (막대바 + 숫자) */}
											{renderSliderInput('wdcpry1', idata.wdcpry1, 0, 100, '㎜', '', true)}
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr tres_tr' : 'standard_tr2 tres_tr'}>
										<td className="k_label13R_f" colSpan="2">
											[이중인쇄 출력2설정]
										</td>
										<td className="k_label13R">내용</td>
										<td className="k_label18L">
											{/* 내용 입력 */}
											<input className="k_inputChkL2" value={idata.wdclbl2} onChange={onChange} maxLength="25" name="wdclbl2" onFocus={handleFocus} />
										</td>
										<td className="k_label13R">색상</td>
										<td className="k_label18L">
											{/* 색상 select */}
											{renderColorSelect('wdccol2', idata.wdccol2, true)}
										</td>
									</tr>
									<tr className={panded === true ? 'standard_tr tres_tr' : 'standard_tr2 tres_tr'}>
										<td className="k_label13R">폰트사이즈&nbsp;</td>
										<td className="k_label18L">
											{/* 폰트사이즈 입력 (막대바 + 숫자) */}
											{renderSliderInput('wdcsiz2', idata.wdcsiz2, 0, 250, 'pt', '', true)}
										</td>
										<td className="k_label13R" title="[이중인쇄 출력2설정] X좌표 : 절취선부터 mm 측정 (글자 폭에 따라 오차범위 존재 : ± 5mm)" style={{ cursor: 'pointer' }}>
											<b>X좌표</b>
										</td>
										<td className="k_label18L">
											{/* X좌표 입력 (막대바 + 숫자) */}
											{renderSliderInput('wdcprx2', idata.wdcprx2, 0, 150, '㎜', '', true)}
										</td>
										<td className="k_label13R" title="[이중인쇄 출력2설정] Y좌표 : 절취선부터 mm 측정" style={{ cursor: 'pointer' }}>
											<b>Y좌표</b>
										</td>
										<td className="k_label18L">
											{/* Y좌표 입력 (막대바 + 숫자) */}
											{renderSliderInput('wdcpry2', idata.wdcpry2, 0, 100, '㎜', '', true)}
										</td>
									</tr>

									<tr className={panded === true ? 'standard_tr tres_tr' : 'standard_tr2 tres_tr'}>
										<td className="k_label13R" title="부품식별표VMI/PO 적입중량 표시 추가(전주공장 중대재해 점검결과 개선지적 사항)" style={{ cursor: 'pointer' }}>
											<b>적입중량(부품당)</b>
										</td>
										<td className="k_label18L">
											{/* 적입중량 입력  20220630 추가 */}
											<input
												className="k_inputChkNumR"
												value={idata.wdcwtun}
												onChange={onChange}
												style={{ WIDTH: '100%', paddingRight: '5px' }}
												maxLength="10"
												name="wdcwtun"
												onFocus={handleFocus}
											/>
											<b>kg</b>
										</td>
										<td className="k_label13R" style={{ verticalAlign: 'top' }}>
											<b>
												사용자 지정 <br></br>용기당수량
											</b>
										</td>
										<td className="">
											{/* 업체 용기당수량 입력  20220708 추가 */}
											<input
												className="k_inputChkNumR"
												value={idata.wrcvnqt}
												onChange={onChange}
												readOnly={idata.wrcvnyn !== 'Y'}
												style={
													idata.wrcvnyn === 'Y'
														? { width: '65%', height: '32px', paddingRight: '5px', border: '1px solid #CECDD9', marginRight: '0px', color: 'red', fontWeight: 'bold' }
														: { width: '65%', height: '32px', paddingRight: '5px', border: '1px solid #CECDD9', marginRight: '0px', backgroundColor: '#e1e0eb', opacity: '0.5' }
												}
												maxLength="13"
												name="wrcvnqt"
												onFocus={handleFocus}
											/>
											<select
												className="k_combo"
												name="wrcvnyn"
												value={idata.wrcvnyn}
												onChange={onChange}
												style={{ width: '29%', paddingRight: '5px', paddingLeft: '5px', border: '1px solid #CECDD9', height: '32px' }}
											>
												{/* 사용여부 Select */}
												<option value=" "></option>
												<option value="Y">Y</option>
												<option value="N">N</option>
											</select>
										</td>
									</tr>
								</tbody>
							</table>
							{/* ── 식별표 미리보기 + 이중인쇄 샘플러 우측/드래그 이동 플로팅 패널 (입력폼 동시 수정 가능) ─────────────── */}
							{samplerOpen && (
								<div style={{
									position: 'fixed',
									top: modalPos.x !== null ? `${modalPos.y}px` : '70px',
									left: modalPos.x !== null ? `${modalPos.x}px` : 'auto',
									right: modalPos.x === null ? '20px' : 'auto',
									zIndex: 1200,
									width: showSamplerPresetList ? '1060px' : '580px',
									maxWidth: '96vw',
									maxHeight: 'calc(100vh - 80px)',
									background: '#ffffff',
									borderRadius: '10px',
									boxShadow: '0 10px 30px rgba(0, 0, 0, 0.18)',
									display: 'flex',
									flexDirection: 'column',
									overflow: 'hidden',
									border: '1px solid #cbd5e1',
									userSelect: isDragging ? 'none' : 'auto',
								}}>
									{/* 헤더 (솔리드 클린 테마 + 적용하기 버튼) */}
									<div
										onMouseDown={onMouseDownHeader}
										title="마우스로 클릭 후 드래그하여 원하는 위치로 이동하세요"
										style={{
											padding: '10px 16px',
											background: '#f8fafc',
											color: '#0f172a',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											borderBottom: '1px solid #e2e8f0',
											cursor: isDragging ? 'grabbing' : 'grab',
											userSelect: 'none',
										}}
									>
										<div style={{ display: 'flex', alignItems: 'center', gap: '8px', pointerEvents: 'none' }}>
											<span style={{ fontWeight: 'bold', fontSize: '13px', letterSpacing: '-0.3px', color: '#0f172a' }}>
												실시간 미리보기 & 이중인쇄 설정
											</span>
										</div>
										<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
											{/*  적용하기 버튼 (단색 적용) */}
											<button
												type="button"
												onClick={onUpdate}
												title="현재 수정한 설정을 시스템에 적용(수정)합니다"
												style={{
													padding: '5px 13px',
													background: 'rgb(0 87 244)',
													color: '#ffffff',
													border: 'none',
													borderRadius: '4px',
													cursor: 'pointer',
													fontSize: '11px',
													fontWeight: 'bold',
													display: 'flex',
													alignItems: 'center',
													gap: '4px',
													boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
													transition: 'all 0.15s',
												}}
											>
												<span>적용하기</span>
											</button>
											{/*  기존 설정 복원 (초기화) 버튼 */}
											<button
												type="button"
												onClick={onResetSamplerDualPrint}
												title="샘플 선택 전의 기존 설정값으로 복원합니다"
												style={{
													padding: '5px 12px',
													background: '#f1f5f9',
													color: '#334155',
													border: '1px solid #cbd5e1',
													borderRadius: '4px',
													cursor: 'pointer',
													fontSize: '11px',
													fontWeight: 'bold',
													display: 'flex',
													alignItems: 'center',
													gap: '4px',
													transition: 'all 0.15s',
												}}
											>
												<span>초기화</span>
											</button>
											{/* 닫기 버튼 */}
											<button
												type="button"
												onClick={onToggleSampler}
												style={{
													background: '#ffffff',
													border: '1px solid #cbd5e1',
													color: '#475569',
													width: '24px',
													height: '24px',
													borderRadius: '50%',
													cursor: 'pointer',
													fontSize: '12px',
													fontWeight: 'bold',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													transition: 'all 0.15s',
												}}
												title="닫기"
											>
												✕
											</button>
										</div>
									</div>

									{/* 팝업 본문 (좌/우 2컬럼 레이아웃) */}
									<div style={{
										display: 'flex',
										flexDirection: 'row',
										flex: 1,
										minHeight: 0,
										overflow: 'hidden',
										background: '#ffffff',
										padding: '12px',
										gap: '12px',
										maxHeight: 'calc(100vh - 140px)',
									}}>
										{/* 좌측 컬럼: 미리보기 컨트롤 + Canvas */}
										<div style={{
											flex: '1 1 560px',
											minWidth: 0,
											minHeight: 0,
											display: 'flex',
											flexDirection: 'column',
											gap: '10px',
											overflowY: 'auto',
											paddingRight: '2px',
										}}>
											<div style={{
												background: '#f8fafc',
												borderRadius: '8px',
												border: '1px solid #e2e8f0',
												padding: '10px',
												display: 'flex',
												flexDirection: 'column',
												gap: '8px',
											}}>
												{/* 미리보기 설정 + 이중인쇄 출력 1/2 통합 조절 UI */}
												<div style={{ display: 'flex', flexDirection: 'column', gap: '8px', background: '#ffffff', padding: '8px 10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>

													{/* 1줄: 미리보기 공통 설정 (L/R, 크기, 핸들) */}
													<div style={{ display: 'flex', gap: '14px', alignItems: 'center', flexWrap: 'wrap', fontSize: '10px' }}>
														{/* L/R 구분 */}
														<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
															<span style={{ color: '#475569', fontWeight: 'bold' }}>L/R:</span>
															<select
																className="k_combo"
																name="wdcckgb"
																value={idata.wdcckgb}
																onChange={onChange}
																style={{ border: '1px solid #cbd5e1', borderRadius: '4px', padding: '1px 4px', fontSize: '10px', height: '22px', background: '#ffffff' }}
															>
																<option value=" "></option>
																{idata.wdcckgbList.map((element) => (
																	<option key={'prev_wdcckgb_' + element.comCode} value={element.comCode}>
																		{element.text}
																	</option>
																))}
															</select>
														</div>

														{/* 크게/작게 */}
														<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
															<span style={{ color: '#475569', fontWeight: 'bold' }}>크기:</span>
															<select
																className="k_combo"
																name="wdccklg"
																value={idata.wdccklg}
																onChange={onChange}
																disabled={!(['L', 'R'].includes((idata.wdcckgb || '').trim()))}
																style={{
																	border: '1px solid #cbd5e1', borderRadius: '4px', padding: '1px 4px', fontSize: '10px', height: '22px', background: '#ffffff',
																	opacity: !(['L', 'R'].includes((idata.wdcckgb || '').trim())) ? 0.5 : 1,
																	cursor: !(['L', 'R'].includes((idata.wdcckgb || '').trim())) ? 'not-allowed' : 'pointer'
																}}
															>
																<option value=""> </option>
																<option key={'prev_wrccklg_L'} value={"L"}>크게</option>
																<option key={'prev_wrccklg_S'} value={"S"}>작게</option>
															</select>
														</div>

														{/* 핸들 (라디오 버튼) */}
														<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
															<span style={{ color: '#475569', fontWeight: 'bold' }}>핸들:</span>
															<div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
																{[
																	{ id: 'rthd', label: 'RHD', checked: idata.wdcrthd === 'Y' && idata.wdclthd !== 'Y', action: { wdcrthd: 'Y', wdclthd: 'N' } },
																	{ id: 'lthd', label: 'LHD', checked: idata.wdclthd === 'Y' && idata.wdcrthd !== 'Y', action: { wdcrthd: 'N', wdclthd: 'Y' } },
																	{ id: 'no',   label: 'NO',  checked: idata.wdcrthd !== 'Y' && idata.wdclthd !== 'Y', action: { wdcrthd: 'N', wdclthd: 'N' } },
																].map((opt) => (
																	<label key={opt.id} style={{ display: 'inline-flex', alignItems: 'center', gap: '1px', cursor: 'pointer', color: '#334155', fontWeight: opt.checked ? 'bold' : 'normal' }}>
																		<input
																			type="radio"
																			name="prev_handle_radio"
																			checked={opt.checked}
																			onChange={() => setData({ ...idata, ...opt.action })}
																			style={{ margin: 0, cursor: 'pointer', accentColor: '#334155' }}
																		/>
																		{opt.label}
																	</label>
																))}
															</div>
														</div>

														{/* 차량위치 (WRCPSUB: ARGB + FRT/RR) */}
														<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
															<span style={{ color: '#475569', fontWeight: 'bold' }}>차량위치:</span>
															<div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
																{[
																	{ id: 'frt', label: 'FRT(전면)', position: 'FRT', value: SUB_PRINT_POSITION_VALUES.FRT },
																	{ id: 'rr', label: 'RR(후면)', position: 'RR', value: SUB_PRINT_POSITION_VALUES.RR },
																	{ id: 'none', label: '선택안함', position: '', value: SUB_PRINT_POSITION_VALUES.NONE },
																].map((opt) => (
																	<label key={opt.id} style={{ display: 'inline-flex', alignItems: 'center', gap: '1px', cursor: 'pointer', color: '#334155', fontWeight: selectedSubPrintPosition === opt.position ? 'bold' : 'normal' }}>
																		<input
																			type="radio"
																			name="prev_vehicle_position_radio"
																			checked={selectedSubPrintPosition === opt.position}
																			onChange={() => setData((prev) => ({ ...prev, wrcpsub: opt.value }))}
																			style={{ margin: 0, cursor: 'pointer', accentColor: '#334155' }}
																		/>
																		{opt.label}
																	</label>
																))}
															</div>
														</div>
													</div>

													{/* 2줄: 식별표 배경색 설정 (중앙색, 하단색 - 독립 행 배치) */}
													<div style={{ display: 'flex', gap: '14px', alignItems: 'center', flexWrap: 'nowrap', fontSize: '10px', paddingBottom: '6px', borderBottom: '1px dashed #e2e8f0' }}>
														{/* 중앙색 */}
														<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
															<span style={{ color: '#475569', fontWeight: 'bold' }}>중앙색:</span>
															<select
																className="k_combo"
																name="wrcbgndT"
																value={idata.wrcbgndT || 'N'}
																onChange={(e) => {
																	const val = e.target.value;
																	setData({ ...idata, wrcbgndT: val, wrcbgnd: val + (idata.wrcbgnd2B || 'N') });
																}}
																style={{ border: '1px solid #cbd5e1', borderRadius: '4px', padding: '1px 4px', fontSize: '10px', height: '22px', background: '#ffffff' }}
															>
																<option value="N">적용안함</option>
																<option value="Y">💛 노랑</option>
															</select>
														</div>

														{/* 하단색 */}
														<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
															<span style={{ color: '#475569', fontWeight: 'bold' }}>하단색:</span>
															<select
																className="k_combo"
																name="wrcbgnd2B"
																value={idata.wrcbgnd2B || 'N'}
																onChange={(e) => {
																	const val = e.target.value;
																	setData({ ...idata, wrcbgnd2B: val, wrcbgnd: (idata.wrcbgndT || 'N') + val });
																}}
																style={{ border: '1px solid #cbd5e1', borderRadius: '4px', padding: '1px 4px', fontSize: '10px', height: '22px', background: '#ffffff' }}
															>
																<option value="N">적용안함</option>
																<option value="P">💜 보라</option>
																<option value="G">💚 초록</option>
															</select>
														</div>
													</div>

													{/* 2줄: [이중인쇄 출력1설정] - 내용, 색상, 폰트사이즈, X좌표, Y좌표 */}
													<div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '10px' }}>
														<div style={{ fontWeight: 'bold', color: '#0f172a', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
															① 이중인쇄 출력1 설정
														</div>
														<div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
															{/* 내용 (약 30% 축소) */}
															<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flex: '1.4' }}>
																<span style={{ color: '#475569', fontWeight: 'bold', whiteSpace: 'nowrap' }}>내용:</span>
																<input
																	className="k_inputChkL2"
																	name="wdclbl1"
																	value={idata.wdclbl1 || ''}
																	onChange={onChange}
																	placeholder="출력1 내용"
																	maxLength="25"
																	style={{ flex: 1, minWidth: 0, padding: '2px 5px', fontSize: '10px', height: '22px', border: '1px solid #cbd5e1', borderRadius: '4px' }}
																/>
															</div>
															{/* 색상 (약 50% 축소) */}
															<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flex: '0.7' }}>
																<span style={{ color: '#475569', fontWeight: 'bold', whiteSpace: 'nowrap' }}>색상:</span>
																<div style={{ flex: 1, minWidth: 0 }}>
																	{renderColorSelect('wdccol1', idata.wdccol1, false)}
																</div>
															</div>
															{/* 폰트 크기 막대 */}
															<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flex: '1.2' }}>
																{renderSliderInput('wdcsiz1', idata.wdcsiz1, 0, 250, 'pt', '크기', false)}
															</div>
														</div>
														<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', background: '#f8fafc', padding: '4px 8px', borderRadius: '4px', border: '1px solid #f1f5f9' }}>
															{/* X좌표 */}
															{renderSliderInput('wdcprx1', idata.wdcprx1, 0, 150, '㎜', 'X', false)}
															{/* Y좌표 */}
															{renderSliderInput('wdcpry1', idata.wdcpry1, 0, 100, '㎜', 'Y', false)}
														</div>
													</div>

													{/* 3줄: [이중인쇄 출력2설정] - 내용, 색상, 폰트사이즈, X좌표, Y좌표 */}
													<div style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '10px', paddingTop: '6px', borderTop: '1px dashed #e2e8f0' }}>
														<div style={{ fontWeight: 'bold', color: '#0f172a', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
															② 이중인쇄 출력2 설정
														</div>
														<div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
															{/* 내용 (약 30% 축소) */}
															<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flex: '1.4' }}>
																<span style={{ color: '#475569', fontWeight: 'bold', whiteSpace: 'nowrap' }}>내용:</span>
																<input
																	className="k_inputChkL2"
																	name="wdclbl2"
																	value={idata.wdclbl2 || ''}
																	onChange={onChange}
																	placeholder="출력2 내용"
																	maxLength="25"
																	style={{ flex: 1, minWidth: 0, padding: '2px 5px', fontSize: '10px', height: '22px', border: '1px solid #cbd5e1', borderRadius: '4px' }}
																/>
															</div>
															{/* 색상 (약 50% 축소) */}
															<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flex: '0.7' }}>
																<span style={{ color: '#475569', fontWeight: 'bold', whiteSpace: 'nowrap' }}>색상:</span>
																<div style={{ flex: 1, minWidth: 0 }}>
																	{renderColorSelect('wdccol2', idata.wdccol2, false)}
																</div>
															</div>
															{/* 폰트 크기 막대 */}
															<div style={{ display: 'flex', alignItems: 'center', gap: '3px', flex: '1.2' }}>
																{renderSliderInput('wdcsiz2', idata.wdcsiz2, 0, 250, 'pt', '크기', false)}
															</div>
														</div>
														<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', alignItems: 'center', background: '#f8fafc', padding: '4px 8px', borderRadius: '4px', border: '1px solid #f1f5f9' }}>
															{/* X좌표 */}
															{renderSliderInput('wdcprx2', idata.wdcprx2, 0, 150, '㎜', 'X', false)}
															{/* Y좌표 */}
															{renderSliderInput('wdcpry2', idata.wdcpry2, 0, 100, '㎜', 'Y', false)}
														</div>
													</div>
												</div>

												{/* 식별표 실물 미리보기 Canvas */}
												<div style={{
													background: '#e2e8f0',
													padding: '10px 6px 0px 6px',
													borderRadius: '6px',
													border: '1px solid #cbd5e1',
													display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
													height: '317px',
													overflow: 'hidden',
													width: '100%',
													boxSizing: 'border-box',
												}}>
													<div style={{ transform: 'scale(0.68)', transformOrigin: 'top center', flexShrink: 0 }}>
														{renderLabelPreview()}
													</div>
												</div>
											</div>
										</div>

										{/* 우측 컬럼: 샘플 카드리스트 사이드바 (2열 소형 카드리스트) */}
										{showSamplerPresetList && (
											<div style={{
												width: '460px',
												flex: '0 0 460px',
												display: 'flex',
												flexDirection: 'column',
												gap: '8px',
												background: '#f8fafc',
												borderRadius: '8px',
												border: '1px solid #e2e8f0',
												padding: '8px',
												minHeight: 0,
												overflow: 'hidden',
											}}>
											<div style={{ fontWeight: 'bold', color: '#312e81', fontSize: '12px', borderBottom: '1px solid #e0e7ff', paddingBottom: '6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
												<span>이중인쇄 샘플 목록</span>
												<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
													{/* {samplerSelIdx >= 0 && (
														<button
															type="button"
															onClick={onResetSamplerDualPrint}
															title="샘플 선택 취소 및 기존 설정 복원"
															style={{
																background: '#ef4444',
																color: '#ffffff',
																border: 'none',
																borderRadius: '4px',
																padding: '2px 8px',
																fontSize: '10px',
																fontWeight: 'bold',
																cursor: 'pointer',
																display: 'flex',
																alignItems: 'center',
																gap: '2px',
															}}
														>
															<span>샘플 초기화</span>
														</button>
													)} */}
													{samplerPresets.length > 0 && (
														<span style={{ background: 'rgb(0 87 244)', color: '#fff', borderRadius: '10px', padding: '1px 8px', fontSize: '10px' }}>
															{samplerPresets.length}개 샘플
														</span>
													)}
											</div>
										</div>

										<div
											role="tablist"
											aria-label="식별표 타입별 이중인쇄 샘플"
											style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '4px', flexShrink: 0 }}
										>
											{SAMPLER_TYPE_TABS.map(({ type, sheetCount }) => {
												const isActive = samplerActiveType === type;
												return (
													<button
														type="button"
														role="tab"
														aria-selected={isActive}
														key={type}
														onClick={() => onChangeSamplerType(type)}
														style={{
															padding: '7px 8px',
															border: isActive ? '1px solid #2563eb' : '1px solid #cbd5e1',
															borderRadius: '6px',
															background: isActive ? '#2563eb' : '#ffffff',
															color: isActive ? '#ffffff' : '#475569',
															fontSize: '11px',
															fontWeight: 'bold',
															cursor: 'pointer',
															transition: 'all 0.15s',
														}}
													>
														{type} ({sheetCount}매)
													</button>
												);
											})}
										</div>

										{samplerLoading ? (
												<div style={{ textAlign: 'center', color: '#64748b', padding: '24px 0', fontSize: '11px' }}>샘플 미리보기 로딩 중...</div>
											) : samplerPresets.length === 0 ? (
												<div style={{ textAlign: 'center', color: '#94a3b8', padding: '24px 0', fontSize: '11px' }}>
													{idata.wdcplnt ? `[공장 ${idata.wdcplnt}] 등록된 샘플이 없습니다.` : '조회된 공장의 샘플이 없습니다.'}
												</div>
										) : (
											<div style={{
												display: 'grid',
												gridTemplateColumns: '1fr 1fr',
												gridAutoRows: 'max-content',
												alignContent: 'start',
												gap: '8px',
												flex: 1,
												minHeight: 0,
												overflowY: 'auto',
												paddingRight: '4px'
											}}>
												{samplerPresets.map((preset, idx) => {
													const isSelected = samplerSelIdx === idx;
													const presetName = getSamplerPresetName(preset, idx);
													return (
														<div
															key={idx}
															onClick={() => onApplySamplerPreset(preset, idx)}
															title={presetName}
															style={{
																	cursor: 'pointer',
																	border: isSelected ? '2px solid #6366f1' : '1px solid #cbd5e1',
																	borderRadius: '6px',
																	overflow: 'hidden',
																	background: '#ffffff',
																	boxShadow: isSelected ? '0 3px 8px rgba(99, 102, 241, 0.25)' : '0 1px 2px rgba(0,0,0,0.04)',
																	transition: 'all 0.15s',
																	opacity: samplerSelIdx >= 0 && !isSelected ? '0.85' : '1',
																	display: 'flex',
																	flexDirection: 'column',
																	justifyContent: 'space-between',
																}}
															>
																{/* 카드 헤더 */}
																<div style={{
																	padding: '4px 6px', fontSize: '10px', fontWeight: 'bold',
																	color: isSelected ? '#3730a3' : '#0f172a',
																	background: isSelected ? '#e0e7ff' : '#f1f5f9',
																	borderBottom: '1px solid #e2e8f0',
																	display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '4px'
																}}>
															<span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={presetName}>
																{presetName}
																	</span>
																	<div style={{
																		width: '13px', height: '13px', borderRadius: '3px',
																		background: isSelected ? '#6366f1' : '#ffffff',
																		border: isSelected ? '1px solid #6366f1' : '1px solid #cbd5e1',
																		display: 'flex', alignItems: 'center', justifyContent: 'center',
																		color: '#ffffff', fontSize: '9px', fontWeight: 'bold', flexShrink: 0
																	}}>
																		{isSelected && '✓'}
																	</div>
																</div>

																{/* 카드 썸네일 미리보기 (위치 확인 가능) */}
																{buildSamplerCardThumbnail(preset)}

																{/* 카드 푸터 (이중인쇄 ①, ② 전체 내용 다 보이도록 노출) */}
																<div style={{
																	padding: '4px 6px',
																	fontSize: '10px',
																	fontWeight: '500',
																	color: '#334155',
																	background: isSelected ? '#f5f3ff' : '#ffffff',
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '2px',
																	lineHeight: '1.2'
																}}>
																	{/* {preset.wdclbl1 ? (
																		<div style={{ wordBreak: 'break-all', color: '#1e293b' }} title={`① ${preset.wdclbl1}`}>
																			<span style={{ color: '#4f46e5', fontWeight: 'bold' }}>①</span> {preset.wdclbl1}
																		</div>
																	) : null}
																	{preset.wdclbl2 ? (
																		<div style={{ wordBreak: 'break-all', color: '#1e293b' }} title={`② ${preset.wdclbl2}`}>
																			<span style={{ color: '#0284c7', fontWeight: 'bold' }}>②</span> {preset.wdclbl2}
																		</div>
																	) : null}
																	{!preset.wdclbl1 && !preset.wdclbl2 && (
																		<div style={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '9px' }}>이중인쇄 없음</div>
																	)} */}
																</div>
															</div>
														);
													})}
												</div>
											)}
											</div>
										)}
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</ContentTwo>
		</>
	);
}
export default ROM4L;
